'use strict';

angular.module('mobile-apps').controller('LanguageEntriesController', [
      '$window',
      '$scope',
      '$rootScope',
      '$stateParams',
      '$location',
      '$modal',
      '$state',
      '$http',
      '$sce',
      '$filter',
      '$timeout',
      'filterFilter',
      'Authentication',
	  'TeamData',
	  'Teams',
      'EntryStatus',
      'EntryWarnings',
      'LanguageEntries',
      'ApproveLanguageEntries',
      'ApproveAllLanguageEntries',
      'MobileAppSubscription',
      'EventTracker',
      'AvailableLanguages',
      'GlossaryMain',
      'SweetAlert',
      'TranslationMemory',
      'FilesLanguageEntries',
      'FileUploader',
      'TranslationImport',
      'Utilities',
      'Groups',
      'Tags',
      'TagMain',
      'FileMain',
      'EntryDetail',
      'EntryMain',
      'EntryCount',
      'MultiActionEntries',
      'focusElement',
	  '$aside',
	  '$q',
	  'LockEntry',
		'JiraApi',
		'DEFAULT_TAG_CATEGORIES',
      function ($window,
                $scope,
                $rootScope,
                $stateParams,
                $location,
                $modal,
                $state,
                $http,
                $sce,
                $filter,
                $timeout,
                filterFilter,
                Authentication,
				TeamData,
				Teams,
                EntryStatus,
                EntryWarnings,
                LanguageEntries,
                ApproveLanguageEntries,
                ApproveAllLanguageEntries,
                MobileAppSubscription,
                EventTracker,
                AvailableLanguages,
                GlossaryMain,
                SweetAlert,
                TranslationMemory,
                FilesLanguageEntries,
                FileUploader,
                TranslationImport,
                Utilities,
                Groups,
                Tags,
                TagMain,
                FileMain,
                EntryDetail,
                EntryMain,
                EntryCount,
                MultiActionEntries,
                focusElement,
				$aside,
				$q,
				LockEntry,
				JiraApi,
				DEFAULT_TAG_CATEGORIES)
          {

		  $scope.processingImport = false;
		  $scope.processingExport = false;
		  $scope._scrollToEntryRunning = false;
		  $scope.tagCategories = [];
		  $scope.languageEntryStatesCountMap = {};
		  $scope.userGroups = [];


		  $scope.entryCounts = [
			  {
				  name: 'Untranslated',
				  filter: {
					  value: '',
					  draft: '',
					  locked: false
				  },
				  color: 'red',
				  value: 0
			  },
			  {
				  name: 'Unpublished',
				  filter: {
					  _join: 'AND',
					  terms: [
						  {
							  _not: true,
							  draft: ''
						  },
						  {
							  locked: false
						  }
					  ]
				  },
				  color: 'orange',
				  value: 0
			  },
			  {
				  name: 'Translated',
				  filter: {
					  _join: 'AND',
					  terms: [
						  {
							  _not: true,
							  value: ''
						  },
						  {
							  locked: false
						  }
					  ]
				  },
				  color: 'green',
				  value: 0
			  },
			  {
				  name: 'Locked',
				  filter: {
					  locked: true
				  },
				  color: 'grey',
				  value: 0
			  }
		  ];

		  $scope.filtering = {
			  property: 'all',
			  searchText: '',
			  customFilters: {},
			  previousCustomFilterValues: {},
			  oldTag: null,
			  oldFileName: null,
			  oldFilterQuery: {},
			  options: [],
			  savedFilters: {},
			  activeFilter: undefined
		  };

		  $scope.countersHtmlPartA = '<span class="info-display-wrapper"><div class="filter-option-counter filter-counter pull-right">';
		  $scope.countersHtmlPartB = {
			  'translated': '</div><div class="highlight-stroke green pull-right" style="margin-top:3px;"></div></span>',
			  'untranslated': '</div><div class="highlight-stroke red pull-right" style="margin-top:3px;"></div></span>',
			  'unpublished': '</div><div class="highlight-stroke orange pull-right" style="margin-top:3px;"></div></span>',
			  'locked': '</div><div class="highlight-stroke grey pull-right" style="margin-top:3px;"></div></span>',
			  'needsAttention': '</div><entry-status status="2"></entry-status><entry-status status="3"></entry-status><entry-status status="4"></entry-status></span>',
			  'inOrder': '</div><entry-status status="5" class="pull-right"></entry-status></span>',
			  'new': '</div><entry-status status="" class="pull-right"></entry-status></span>',
			  'needsTranslation': '</div><entry-status status="3" class="pull-right"></entry-status></span>',
			  'needsReview': '</div><entry-status status="2" class="pull-right"></entry-status></span>',
			  'rejected': '</div><entry-status status="4" class="pull-right"></entry-status></span>',
			  'accepted': '</div><entry-status status="1" class="pull-right"></entry-status></span>',
			  'tagCategories': '</div>',
			  'duplicates': '</div><div class="pull-right filter-icon"><i class="fa fa-files-o" aria-hidden="true"></i></div></span>',
			  'inconsistencies': '</div><div class="pull-right filter-icon"><i class="fa fa-comments-o" aria-hidden="true"></i></div></span>',
			  'noTags': '</div><div class="pull-right filter-icon"><i class="fas fa-tags crossed-icon" aria-hidden="true" style="font-size:10pt"></i></div></span>',
			  'issues': '</div>',
			  'withIssues': '</div><div class="pull-right filter-icon"><i class="fa fa-lg fa-exclamation" aria-hidden="true"></i></div></span>',
			  'issuesGlossaryTermMissing': '</div><div class="pull-right filter-icon"><i class="fa fa-book" aria-hidden="true"></i></div></span>',
			  'issuesSourceChanged': '</div><div class="pull-right filter-icon"><i class="fa fa-chain-broken" aria-hidden="true"></i></div></span>',
			  'issuesToLong': '</div><div class="pull-right filter-icon"><i class="fa fa-ellipsis-h" aria-hidden="true"></i></div></span>',
			  'issuesVariableMissing': '</div><div class="pull-right filter-icon"><i class="fa fa-database" aria-hidden="true"></i></div></span>'
		  };

		  $scope.defaultFilterOptions = [
			{
				key: 'all',
				name: 'All',
				filter: {},
				_postSeparator: true,
				_addHtml: ''
			},
			{
				key: 'translated',
				name: 'Translated',
				filter: {
					_join: 'AND',
					terms: [
						{
							_not: true,
							value: ''
						},
						{
							locked: false
						}
					]
				},
				type: 1,
				_addHtml: null
			},
			{
				key: 'untranslated',
				name: 'Untranslated',
				filter: {
					value: '',
					draft: '',
					locked: false
				},
				type: 1,
				_addHtml: null
			},
			{
				key: 'unpublished',
				name: 'Unpublished',
				filter:
				{
					_join: 'AND',
					terms: [
						{
							_not: true,
							draft: ''
						},
						{
							locked: false
						}
					]
				},
				type: 1,
				_addHtml: null
			},
			{
				key: 'locked',
				name: 'Locked',
				filter: {
					locked: true
				},
				type: 1,
				_postSeparator: true,
				_addHtml: null
			},
			{
				key: 'needsAttention',
				name: 'Needs Attention',
				filter: {
					status: [2, 3, 4]
				},
				type: 2,
				_addHtml: null
			},
			{
				key: 'inOrder',
				name: 'In Order',
				filter: {
					status: 5
				},
				type: 2,
				_addHtml: null
			},
			{
				key: 'new',
				name: 'New',
				filter: {
					_not: true,
					status: [1, 2, 3, 4, 5]
				},
				type: 2,
				_addHtml: null
			},
			{
				key: 'needsTranslation',
				name: 'Needs Translation',
				filter: {
					status: 3
				},
				type: 2,
				_addHtml: null
			},
			{
				key: 'needsReview',
				name: 'Needs Review',
				filter: {
					status: 2
				},
				type: 2,
				_addHtml: null
			},
			{
				key: 'rejected',
				name: 'Rejected',
				filter: {
					status: 4
				},
				type: 2,
				_addHtml: null
			},
			{
				key: 'accepted',
				name: 'Accepted',
				filter: {
					status: 1
				},
				type: 2,
				_postSeparator: true,
				_addHtml: null
			},
			{
				key: 'tagCategories',
				name: 'Tag Categories',
				type: 3,
				_isSubmenu: true,
				_postSeparator: true
			},
			{
				key: 'duplicates',
				name: 'Duplicates',
				type: 2,
				filter: {
					isDuplicate: true
				},
				callback: function () {
					$scope.changeSorting('value');
				},
				hideInBaseLanguage: false,
				_addHtml: null
			},
			{
				key: 'inconsistencies',
				name: 'Inconsistencies',
				type: 2,
				filter: {
					isInconsitent: true
				},
				callback: function () {
					$scope.changeSorting('baseValue');
				},
				hideInBaseLanguage: true,
				_addHtml: null
			},
			{
				key: 'noTags',
				name: 'No Tags',
				type: 2,
				filter: {
					noTags: true
				},
				_addHtml: null
			},
			{
				key: 'issues',
				name: 'With Issues',
				_isSubmenu: true,
				type: 2,
				_addHtml: null
			},
			{
				key: 'withIssues',
				name: 'Any',
				filter: {
					hasIssues: true
				},
				parent: 'issues',
				type: 2,
				hideInBaseLanguage: true,
				_addHtml: null
			},
			{
				key: 'issuesGlossaryTermMissing',
				name: 'Glossary term missing',
				filter: {
					hasIssuesGlossaryTermMissing: true
				},
				parent: 'issues',
				hideInBaseLanguage: true,
				type: 2,
				_addHtml: null
			},
			{
				key: 'issuesSourceChanged',
				name: 'Translation Outdated',
				filter: {
					hasIssuesSourceChanged: true
				},
				parent: 'issues',
				hideInBaseLanguage: true,
				type: 2,
				_addHtml: null
			},
			{
				key: 'issuesToLong',
				name: 'Too long',
				filter: {
					hasIssuesToLong: true
				},
				parent: 'issues',
				type: 2,
				_addHtml: null
			},
			{
				key: 'issuesVariableMissing',
				name: 'Variable missing',
				filter: {
					hasIssuesVariableMissing: true
				},
				parent: 'issues',
				type: 2,
				hideInBaseLanguage: true,
				_addHtml: null
			}
		];

		$scope.initFiltersCounters = function(){
			$scope.filtersCountersReady = false;
			return new Promise(function(resolve, reject){
				async.parallel({
					filtersCounts: function(callback){
						EntryCount.getAllCountforLanguages(
						{	languageId : $stateParams.languageId,
							mobileAppId : $stateParams.mobileAppId,
							groupId: $stateParams.groupId || $scope.groupId
						}, function(languageStatesCounts){ 
							$scope.languageEntryStatesCountMap[$stateParams.languageId] = languageStatesCounts;
							return callback(); 
						}); 
					},
					tags: function(callback){
						$scope.initTags(true).then(function(){
							$scope.addTagCategories(false);
							return callback();
						});
					}
				}, function(err, results){
					if (err) {
						return;
					}
					var defaultFilterOptionsfiltered = $scope.defaultFilterOptions.filter(function(item){
						return Object.keys($scope.countersHtmlPartB).some(function(key){
							return key === item.key || item.key.includes('tagCategory.');
						});
					});
	
					var tagCategoriesMap;
					defaultFilterOptionsfiltered.forEach(function(item, index){
						if(item){
							var filterKey;
							switch (item.key) {
								case 'untranslated':
									filterKey = 'notTranslated';
									break;
								case 'unpublished':
									filterKey = 'draft';
									break;
								case 'withIssues':
									filterKey = 'issues';
									break;
								default:
									filterKey = item.key;
									break;
							}
							switch (item.type) {
								case 1:
								case 2:
									item._addHtml = $sce.trustAsHtml( $scope.countersHtmlPartA + 
											$scope.languageEntryStatesCountMap[$stateParams.languageId][filterKey] + 
											$scope.countersHtmlPartB[item.key] );
									break;
								case 3:
									var tagCategoriesCount = 0;
									tagCategoriesMap = $scope.languageEntryStatesCountMap[$stateParams.languageId][filterKey];
									if(tagCategoriesMap){
										Object.keys(tagCategoriesMap).forEach(function(tagCategory){
											if($scope.tagCategories.some(function(tc){ return tc.name === tagCategory; })){
												tagCategoriesCount += parseInt(tagCategoriesMap[tagCategory]);
											}
										});
									} 
									item._addHtml = $sce.trustAsHtml( $scope.countersHtmlPartA + 
										tagCategoriesCount + 
										$scope.countersHtmlPartB[item.key] );
									break;
								case 4:
									var tagCategoryCount = 0;
									filterKey = filterKey.replace('tagCategory.', '');
									tagCategoriesMap = $scope.languageEntryStatesCountMap[$stateParams.languageId].tagCategories;
									if(tagCategoriesMap && tagCategoriesMap[filterKey]){
										tagCategoryCount = tagCategoriesMap[filterKey];
									} 
									item._addHtml = $sce.trustAsHtml( $scope.countersHtmlPartA + 
											tagCategoryCount + 
											item.htmlToAdd );
									break;
								default:
									break;
							}
						}
						if(index === defaultFilterOptionsfiltered.length - 1){
							$scope.filtersCountersReady = true;
							return resolve();
						}
					});
				});
			}); 
		  };
		  
		  // Data for sorting the entries
		  $scope.sorting = {
			  property: '_id',
			  orderDesc: false,
			  options: [
				  {
					  key: 'key',
					  name: 'ID'
				  },
				  {
					  key: 'baseValue',
					  name: 'Source Text',
					  hideInBaseLanguage: true
				  },
				  {
					  key: 'value',
					  name: 'Target Text'
				  },
				  {
					  key: 'draft',
					  name: 'Draft'
				  },
				  {
					  key: 'valueUpdatedAt',
					  name: 'Change Date',
					  reverse: true
				  },
				  {
					  key: '_id',
					  name: 'Creation Date',
					  reverse: true
				  }
			  ]
		  };



		  $scope.dropdownStatus = {
			  filter: false,
			  sort: false
		  };


		  /**
		   * Add the different filter options to the list
		   */
		  $scope.updateFilterOptions = function() {

			  // Add the custom filters
			  TeamData.get({
				  teamId: $scope.mobileApp.team._id,
				  category: 'filters'
			  }, function (filter) {
				  $scope.filtering.savedFilters = filter.result;

				  $scope.filtering.options.length = 0;
				  // Add all the default filter options
				  $scope.filtering.options.push.apply($scope.filtering.options, $scope.defaultFilterOptions);

				  // Add the filters the user has
				  var filterKeys = Object.keys(filter.result).sort();

				  if (filterKeys.length === 0) {
					  // User does not have any custom filters

					  // So add the custom filter option without and subitems
					  $scope.filtering.options.push({
						  key: 'customFilter.__current__',
						  name: 'Custom',
						  callback: function(previousFilter) {
							  var emptyFilter = true;
							  if (previousFilter === 'customFilter.__current__') {
							  	emptyFilter = false;
							  }
							  $scope.openCustomFilterModal(emptyFilter, previousFilter);
						  },
						  _addHtml: ''
					  });

				  } else {
					  // User has custom filters saved

					  // So add the custom-filter parent with all the custom-filters
					  $scope.filtering.options.push({
						  key: 'customFilter',
						  name: 'Custom',
						  _isSubmenu: true
					  });


					  // Create helper function here because jshint does not
					  // allow to create create it as closure in the loop.
					  var getCustomFunction = function(filterKey) {
						  return function(previousFilter) {
						  	if ($scope.filtering.activeFilter === filterKey) {
						  		// If the filter is already active open it
								$scope.openCustomFilterModal(false, previousFilter);
							} else {
						  		// If not active apply the filter
								$scope.applyCustomFilter(filterKey);
							}
						  };
					  };

					  // Add all the custom filters
					  for (var i=0;i<filterKeys.length;i++) {
						  var filterKey = filterKeys[i];
						  var filterData = {
							  key: 'customFilter.' + filterKey,
							  name: filterKey,
							  parent: 'customFilter',
							  callback: getCustomFunction(filterKey),
							  _addHtml: ''
						  };
						  if (i === (filterKeys.length-1)) {
							  filterData._postSeparator = true;
						  }
						  $scope.filtering.options.push(filterData);
					  }

					  // Add "Current" option in case custom filter is active
					  // but not saved
					  if ($scope.filtering.property === 'customFilter.__current__') {
						  $scope.filtering.options.push({
							  key: 'customFilter.__current__',
							  name: 'Current',
							  parent: 'customFilter',
							  callback: function(previousFilter) {
								  $scope.openCustomFilterModal(false, previousFilter);
							  },
							  _addHtml: ''
						  });
					  }


					  // Add the create new filter option which should always
					  // be last in the list
					  $scope.filtering.options.push({
						  key: 'customFilter.__new__',
						  name: 'Create Filter',
						  parent: 'customFilter',
						  callback: function(previousFilter) {
							  $scope.openCustomFilterModal(true, previousFilter);
						  },
						  _addHtml: ''
					  });
				  }
			  }, function (err) {
				  // Filters could not be loaded
				  console.log(err);

				  // Add at least all the default filter options
				  $scope.filtering.options.length = 0;
				  $scope.filtering.options.push.apply($scope.filtering.options, $scope.defaultFilterOptions);
			  });
		  };


		  /**
		   * Apply the filter values of a given filter key
		   */
		  $scope.applyCustomFilter = function(filterKey) {

			  $scope.filtering.property = 'customFilter.' + filterKey;
			  $scope.filtering.activeFilter = filterKey;

			  var filterValues = $scope.filtering.savedFilters[filterKey];

			  $scope.applyFilterValues(filterValues);
		  };


		  /**
		   * The key of the dropdown to toggle
		   */
		  $scope.toggleDropdown = function(key, $event) {
			  $event.preventDefault();
			  $event.stopPropagation();
			  $scope.dropdownStatus[key] = !$scope.dropdownStatus[key];
		  };


		  /**
		   * Returns the sort order data for the given key
		   */
		  $scope.getSortOrderData = function(key) {
			  var options = $scope.sorting.options;
			  for (var i=0;i<options.length;i++) {
				  if (options[i].key === key) {
					  return options[i];
				  }
			  }

			  return {};
		  };


		  /**
		   * Returns the name to display for the top menu
		   * @returns {string}
		   */
		  $scope.getFilteringTopName = function(key) {
			  var filterOption = $scope.getFilteringData(key);

			  if (filterOption.key === 'customFilter.__current__') {
			  	return 'Custom';
			  }

			  return filterOption.name;
		  };


		  /**
		   * Returns the filter data for the given key
		   */
		  $scope.getFilteringData = function(key) {
			  var options = $scope.filtering.options;
			  for (var i=0;i<options.length;i++) {
				  if (options[i].key === key) {
					  return options[i];
				  }
			  }

			  return {};
		  };


		  /**
		   * Returns the submenus of the given option key if there are any
		   * @param key The option key to get the submenus of
		   * @returns {Array}
		   */
		  $scope.optionSubmenus = function(key) {
			  var subitems = [];
			  var options = $scope.filtering.options;
			  for (var i=0;i<options.length;i++) {
				  if (options[i].parent === key) {
					  subitems.push(options[i]);
				  }
			  }

			  return subitems;
		  };


		  /**
		   * Changes the active filter
		   */
		  $scope.changeFiltering = function(filterKey) {
			  var previousFilter = $scope.filtering.property;
			  var filteringData = $scope.getFilteringData(filterKey);
			  
			  if (filteringData._isSubmenu === true) {
				  // If it is only the parent entry of a submenu there
				  // is nothing to do
				  return;
			  }
			  
			  // Setting state workflow on URL
			  var lastStatePart = $scope.getLastStatePart();
			  var stateWorkflows = ['translated', 'untranslated', 'unpublished', 'locked', 'needsAttention', 'inOrder', 'new', 'needsTranslation', 'needsReview', 'rejected', 'accepted'];
			  if(stateWorkflows.indexOf(filterKey) >= 0){
				if($state.current.name.indexOf('state') !== -1){
					$state.go('.', {stateName: filterKey}, {inherit: true, notify: false});
				} else {
					if($state.current.name.indexOf('edit') !== -1){
						$state.go($state.current.name.replace('.edit', '.state.edit'), {entryId: $scope.entryId, stateName: filterKey}, {inherit: true, notify: false});
					} else if($state.current.name.indexOf('new') !== -1){
						$state.go($state.current.name.replace('.new', '.state.new'), {entryId: $scope.entryId, stateName: filterKey}, {inherit: true, notify: false});
					} else {
						$state.go('.state', {stateName: filterKey}, {inherit: true, notify: false});
					}
				}
			  } else if($state.current.name.indexOf('state') !== -1 && stateWorkflows.indexOf(previousFilter) >= 0) {
				$state.go($state.current.name.replace('.state', ''), {}, {inherit: true, notify: false});
			  }
			  
			  $scope.filtering.property = filterKey;

			  // Track whenever the filter gets changed
			  var eventData = {
				  filter_property: $scope.filtering.property
			  };
			  EventTracker.track('Filter Changed', 'Filter', eventData);

			  if (filteringData.hasOwnProperty('callback')) {
				  filteringData.callback(previousFilter);
			  } else {
				  $scope.updateViewList(true);
			  }

			  // Update all the different filter options because
			  // they may changed
			  $scope.updateFilterOptions();
		  };


		  /**
		   * Changes how the entries are sorted
		   */
		  $scope.changeSorting = function(sortKey) {
			  if (sortKey === $scope.sorting.property) {
				  $scope.sorting.orderDesc = !$scope.sorting.orderDesc;
			  } else {
				  $scope.sorting.orderDesc = false;
				  $scope.sorting.property = sortKey;
			  }

			  // Track whenever the sorting gets changed
			  var eventData = {
				  sort_property: $scope.sorting.property,
				  sort_order: $scope.sorting.orderDesc?'desc':''
			  };
			  EventTracker.track('Sorting Changed', 'Sorting', eventData);

			  $scope.updateViewList(true);
		  };


          //$scope.loadedStatus = false;
          $scope.authentication = Authentication;
          $scope.languageEntry = {
              key: '',
              value: '',
              description: '',
              group: '',
              fileIds: []
          };

          $scope.breadcrumbs = {
              languageId: $stateParams.languageId,
              mobileAppId: $stateParams.mobileAppId,
			  displayTags: false
          };

		  $scope.noResultTexts = {
			  'default': 'No translation yet, why don\'t you add one?',
			  'fileName': 'The selected file doesn\'t have any translations.',
			  'tag': 'The selected tag doesn\'t have any translations.'
		  };
		  $scope.noResultText = $scope.noResultTexts.default;


		  $scope.toggleLangHistory = function(){

			  var changeLog = {};
			  changeLog.query = {
				  languageId: $stateParams.languageId
			  };
			  if(EntryMain.languages.hasOwnProperty($stateParams.languageId)) {
				  changeLog.headline = 'for Language: ' + $scope.availableLanguages[$scope.language.name];
			  }

			  var asideInstance = $aside.open({
				  templateUrl: 'modules/mobile-apps/views/changelog.client.view.html',
				  controller: 'ChangelogController',
				  placement: 'left',
				  size: 'lg',
				  resolve: {
					  loadData: changeLog
				  }
			  });
		  };


		  /**
		   * Update the different count values
		   */
		  $scope.calculateCounts = function() {
			  var entries = $scope.viewList;
			  $scope.entryCounts.forEach(function(countData) {
				  var filteredEntries = window.SEARCHJS.matchArray(entries, countData.filter);
				  countData.value = filteredEntries.length;
			  });
		  };

		  // Initializes the tags
		  $scope.initTags = function (forceReload) {
			  $scope.tagCategories = angular.copy(DEFAULT_TAG_CATEGORIES);
			  return new Promise(function(resolve, reject){
				async.parallel({
					tags: function (callback) {
						TagMain.loadTags($stateParams.mobileAppId, forceReload, function (err, result) {
							if (err) {
								return;
							}
							$scope.tags = TagMain.tags;
							return callback();
						});
					},
					tagCategories: function (callback) {
						TagMain.loadTagCategories($stateParams.mobileAppId, true, function (err, result) {
							if (err) {
								return;
							}
							if (!jQuery.isEmptyObject(TagMain.tagCategories)) {
								Object.keys(TagMain.tagCategories).forEach(function (tagCategory) {
									if (!$scope.tagCategories.some(function (item) { return item.name === tagCategory.name; })) {
										$scope.tagCategories.push(TagMain.tagCategories[tagCategory]);
									}
								});
							}
							if (!$scope.isSideBarMinimized && TagMain.tag && !TagMain.tag._screenshots.length) {
								$scope.toggleSideBar();
							}
							return callback();
						});
					}
				}, function(result){
					return resolve();
				});
			  }); 
		  };

		  $scope.addTagCategories = function(checkForFilters){
			if(checkForFilters){
				$scope.filtersCountersReady = false;
			}
			$scope.tagCategories.forEach(function (tagCategory, index) {
				if (!$scope.defaultFilterOptions.some(function (item) { return item.name === tagCategory.name; })) {
					var htmlToAdd = '<span class="unicode-icon pull-right" style="color:' + tagCategory.color + ';">' + tagCategory.icon + '</span>';
					$scope.defaultFilterOptions.push({
						key: 'tagCategory.' + tagCategory.name,
						name: tagCategory.name,
						filter: {
							tagCategory: tagCategory.name
						},
						type: 4,
						parent: 'tagCategories',
						htmlToAdd: '</div>' + htmlToAdd,
						_addHtml: $sce.trustAsHtml(htmlToAdd)
					});
				}
				if(checkForFilters && index === $scope.tagCategories.length -1){
					$scope.filtersCountersReady = true;
				}
			});
		  };

		  $scope.initListLanguageEntriesView = function (callback) {
			  $scope.setLayoutDependingOnState();

			  // To display tag-entry in breadcrumbs
			  if ($state.current.name.indexOf('viewLanguage.entry.tag') === 0) {
				  $scope.breadcrumbs.displayTags = true;
			  }

			  if ($state.current.name === 'viewLanguage') {
				  // Nobody is allowed to use the parent route "viewLanguage"
				  // so we change automatically to the correct one
				  $state.go('viewLanguage.entry', {}, { inherit: true, notify: false });
			  }

			  /** hack to prevent chrome from blocking scroll events  ***/
			  /*var viewPort = $window.document.getElementById('listViewPort');

			   $scope.debouncedTriggerScroll = _.debounce(function() {
			   viewPort.dispatchEvent(new Event('scroll'));
			   }, 36);

			   viewPort.addEventListener('mousewheel', function(e) {
			   $scope.debouncedTriggerScroll();
			   });*/
			  /** END hack **/


			  $scope.pageData = {};
			  $scope.pageData.uiScrollAdapter = undefined;

			  $scope.viewList = [];

			  $scope.sourceLanguageToShow = 'en'; // Set reasonable default till actualy value set

			  $scope.windowHeightOffset = 230;//offset which includes header panel header borders etc which need to be excluded when matching list to windowsize

			  $scope.pageData.scrollInfo = {
			  };
			  $scope.pageData.dataSource = {
				  //isLoading: false,
				  get: function () {
					  return $scope.viewList;
				  },
				  getHeight: function (entry) {
					  // Returns the height of the entry
					  if (entry.draft && entry.value) {
						  return 122; // Height width border
					  } else if (entry._tags && entry._tags.length) {
						  return 81; // Height width border
					  }
					  return 70; // Height width border
				  }
			  };

			  $scope.showLoading(true);
			  $scope.showProcessing(false);
			  $scope.allEntriesSelected = false;
			  $scope.allEntriesSelectedIndeterminate = false;
			  $scope.lockedEntrySelected = false;
			  $scope.numEntriesSelected = 0;

			  $scope.selectTypeOptions =
				  {
					  'All': 0,
					  'None': 1,
					  'Untranslated': 2,
					  'Drafts w/o translations': 3,
					  'Drafts w. translations': 4,
					  'Translated': 5,
					  'Locked': 6
				  };

			  $scope.dislayActions = [];
			  $scope.actions =
				  {
					  'Publish': 0,
					  'Lock': 1,
					  'Lock (all languages)': 2,
					  'Unlock': 3,
					  'Unlock (all languages)': 4,
					  'Clear draft': 5,
					  'Clear translation': 6,
					  'Delete (all languages)': 7,
					  'Link (all duplicates)': 11,
					  'Unlink': 12
				  };

			  // AL-850 xliff export did not work in safari because of a bug in
			  // the browser. Sw we do allow export selected only for other
			  // browsers for now.
			  if (navigator.userAgent.indexOf('Safari') === -1 || navigator.userAgent.indexOf('Chrome') !== -1) {
				  $scope.actions['Export selected'] = 13;
			  }

			  $scope.groupLanguageEntryMap = EntryMain.groupLanguageEntryMap;
			  $scope.entryKeyMap = EntryMain.entryKeyMap;

			  $scope.mobileAppId = $stateParams.mobileAppId;
			  $scope.languageId = $stateParams.languageId;
			  $scope.tagId = $stateParams.tagId;
			  $scope.filterFileName = $stateParams.fileName;
			  if ($scope.filterFileName) {
				  $scope.filterFileName = decodeURI($scope.filterFileName);
			  }

			  $scope.availableLanguages = AvailableLanguages.get();

			  $scope.$on('entriesChanged', function () {
				  // Load all entries new and force refresh
				  $scope.refreshEntries();
				  $scope.initFiltersCounters();
			  });

			  $scope.$on('selectEntryByKey', function (event, data) {
				  if (data.hasOwnProperty('key') && data.key) {
					  var newIndex = $scope.getEntryIndexByKey(data.key);

					  if (newIndex !== undefined && newIndex !== null) {
						  if ($rootScope.isDetailViewOpened) {
							  $rootScope.$broadcast('openDetailView', $scope.mobileApp._id, $scope.language._id, $scope.group._id, $scope.entryId, newIndex);
						  } else {
						      const { key, link, linkedKeys } = data;
							  $rootScope.$broadcast('liveEditEntrySelectIndex', { index: newIndex, direction: 'positive', key, link, linkedKeys });
						  }
					  }
				  }
			  });

			  $scope.$on('entryChanged', function (event, data) {
				  // Updates the data of an entry when it changed
				  var newEntryData = data.entry;
				  var entryValue = $scope.setEntryValue(newEntryData.key, newEntryData);

				  if ($scope.activeEntry.entry && $scope.activeEntry.entry.key === entryValue.key) {
					  $scope.updateEntryKeyData($scope.activeEntry.entry, entryValue);
				  }

				  // Update the counts
				  $scope.calculateCounts();
				  $scope.initFiltersCounters();
			  });


			  // Whenever a language entry got deleted we update the tags to not
			  // display the already deleted entries still as part of a tag
			  $scope.$on('tagsChanged', function () {
				  // Load all tags new and force refresh
				  $scope.initTags(true).then(function(){
					$scope.addTagCategories(true);
				  });
			  });

			  
			EntryMain.loadMobileApp($stateParams.mobileAppId, false, function (err, result) {
				if (err) {
					return;
				}

				$scope.mobileApp = EntryMain.mobileApps[$stateParams.mobileAppId];
				$scope.groupId = $scope.getCurrentGroup() || EntryMain.defaultGroup._id;
				$scope.defaultGroup = EntryMain.defaultGroup;
				$scope.groups = EntryMain.groups;
				$scope.groupsArr = Object.values(EntryMain.groups);

				Teams.get({
					teamId: $scope.mobileApp.team._id
				}, function (response) {
					$scope.userGroups = response.userGroups;
				}, function (err) {
						return;
				});

				$scope.initFiltersCounters().then(function(){
					
					// Add all the different filter options
					$scope.updateFilterOptions();
	
					if ($scope.mobileApp.type !== 'tm' && $scope.mobileApp.team && $scope.mobileApp.team.translationMemory) {
						// Add the "Add to Memory" and "Translate from Memory" option
						// only if the team has one and when we are not in the
						// translation memory itself
						$scope.actions['Add to Memory'] = 8;
						$scope.actions['Translate from Memory'] = 9;
					}
	
					$scope.dislayActions = $scope.convertActionsToArray($scope.actions);
	
					$scope.group = EntryMain.groups[$scope.groupId];
	
					$scope.groupLanguageEntryMap[$scope.groupId] = {};
	
					$scope.languages = EntryMain.languages;
					$scope.language = EntryMain.languages[$scope.languageId];
	
					$scope.baseLanguage = _.find($scope.languages, { name: $scope.mobileApp.baseLanguage });
					$scope.sourceLanguage = $scope.baseLanguage;
					$scope.isMasterLang = $scope.language.name === $scope.mobileApp.baseLanguage;
	
					var languagesToLoad = [$scope.languageId];
					if ($stateParams.sourceLanguage && $scope.languages.hasOwnProperty($stateParams.sourceLanguage)) {
						// If a source language is defined load it additionally
						$scope.sourceLanguage = $scope.languages[$stateParams.sourceLanguage];
						languagesToLoad.push($scope.sourceLanguage._id);
					}
					$scope.sourceLanguageToShow = $scope.sourceLanguage.name;
	
					$scope.setUrlAccordingToGroup($scope.groupId);
	
					$scope.getCurrentRoleInApp();
	
					$scope.breadcrumbs.appName = $scope.mobileApp.name;
	
					// Load the glossary data
					GlossaryMain.loadGlossary($scope.mobileAppId, true, function (err, entries) { });
	
					EntryMain.loadEntries($scope.mobileAppId, $scope.groupId, languagesToLoad, false, function (err, result) {
						if (err) {
							return;
						}
	
						$scope.groupLanguageEntryMap = EntryMain.groupLanguageEntryMap;
						$scope.entryKeyMap = EntryMain.entryKeyMap;
	
						if (!$scope.isMasterLang) {
							$scope.refLangValues = EntryMain.groupLanguageEntryMap[$scope.groupId][$scope.baseLanguage._id];
						}
	
	
						// checkLoaded
						$scope.updateEntryKeyMapData();
	
						// if url has state workflow we load the view list filtered
						if ($state.current.name.indexOf('state') !== -1 && $stateParams.stateName) {
							$scope.changeFiltering($stateParams.stateName);
						} else {
							$scope.updateViewList(true);
						}
	
						$scope.showLoading(false);
	
						$rootScope.$broadcast('entriesChangedSuccess');
	
						if ($stateParams.hasOwnProperty('entryId') && $stateParams.entryId) {
							$scope.scrollToEntry($stateParams.entryId);
						}
	
					});
				});
			});
		  };



		  /*********START inplace edit functions START*******/

		  $scope.activeEntry = {
			  entry: undefined,
			  key: undefined
		  };

		  $scope.isAnyEditActive = function() {
			  return $scope.activeEntry.key !== undefined;
		  };

		  $scope.isEditActive = function(languageEntry) {
			  return ($scope.activeEntry.key === languageEntry.key);
		  };

		  // Update selection whenever the an entry gets selected/unselected
		  $scope.$on('liveEditEntrySelectionChanged', function () {
			  var status = $scope.getUpdateEntriesStatusFn();
			  $scope.viewList.forEach(function (entry) {
				  status(entry);
			  });
			  $scope.setAllEntryStatus(status);
		  });

		  // Update the entries whenever they change
		  $scope.$on('liveEditEntryValueChanged', function (event, response) {
				var newEntryData = response.entry;

			  var entryValue = $scope.setEntryValue(newEntryData.key, newEntryData);
			  $scope.updateEntryKeyData($scope.activeEntry.entry, entryValue);

			  // Update the counts
			  $scope.calculateCounts();
			  $scope.initFiltersCounters();
		  });


		  /**
		   * Checks if the entry with the given index is currently visible
		   */
		  $scope.isEntryVisible = function(index) {
			  // Check if the given index is even valid
			  if (index > 0) {
				  // Get the elements we need and check if they have valid values
				  var itemElement = $('#list-group-item-' + index);
				  var parentElement = $('#listViewPort');
				  if (itemElement.position() && parentElement.height()) {
					  var parentHeight = parentElement.height();
					  var itemY = itemElement.position().top;
					  // Check if the entry is currently visible
					  if (itemY > 35 && (itemY + 25) < parentHeight) {
						  return true;
					  }
				  }
			  }

			  return false;
		  };


		  /**
		   * Scrolls to the entry with the given id and sets it state accordingly
		   */
		  $scope.scrollToEntry = function(entryId, numberTries, liveEditMode) {
			  if ($scope._scrollToEntryRunning === true && numberTries === undefined) {
				  // If there is already a scrollToEntry in process ignore
				  // the current request
				  return;
			  }

			  $scope._scrollToEntryRunning = true;

			  if (numberTries === undefined) {
				  numberTries = 20;
			  } else {
				  numberTries--;
				}
				
				if (liveEditMode === undefined) {
				  liveEditMode = true;
			  } 

			  // Check if an entry with the given id can even get displayed
			  var entryIndex = $scope.getEntryIndex(entryId);

			  if (entryIndex === undefined) {
				  // Entry index could not be found

				  if (numberTries <= 0) {
					  // If no tries left stop
					  $scope._scrollToEntryRunning = false;
					  return;
				  }

				  // There are still tries left wait a little bit
				  // and then try again
				  $timeout(function() {
					  $scope.scrollToEntry(entryId, numberTries);
				  }, 25);

			  } else {
				  // It can get displayed but wait first a little bit that
				  // the browser has some time to render the entries before we
				  // check if it is already visible
				  $timeout(function() {
					  // Depending on if it is already visible or not we refresh
					  // the the list. We could always refresh it but then
					  // we would always have this ugly refresh flickering
					  // between every entry change.
					  var entryVisible = $scope.isEntryVisible(entryIndex);
					  if (entryVisible) {
						  // Entry is already visible so et the state
							// (active/not-active) directly
							if(liveEditMode){
								$scope.setEntryDependingOnState();
							}
							if($rootScope.isDetailViewOpened){
								$('display-tags[entry-id=\'' + $scope.entryId + '\']').parents('.list-group-item').addClass('detail-view-active');
							}
						  $scope._scrollToEntryRunning = false;
					  } else {
						  if($scope.pageData && $scope.pageData.dataSource){
							// Entry is currently not visible so reload the list
						  	// so that it becomes visible
						  	$scope.pageData.dataSource.scrollToIndex(entryIndex);
						  }
						  $timeout(function() {
							  // Wait a little bit that the list had time to reload before
								// we set the state (active/not-active)
								if(liveEditMode){
									$scope.setEntryDependingOnState();
								}
								if($rootScope.isDetailViewOpened){
									$timeout(function(){
										$('display-tags[entry-id=\'' + $scope.entryId + '\']').parents('.list-group-item').addClass('detail-view-active');
									}, 150);		
								}
							  $scope._scrollToEntryRunning = false;
						  }, 350);
					  }
				  }, 350);
			  }
		  };



		  // Makes sure that when another entry gets selected it updated the url
		  $scope.$watch('activeEntry.key', function() {

			  if ($state.current.name.indexOf('viewLanguage') !== 0) {
				  return;
			  }

			  if ($scope.activeEntry.key) {
				  var newEntryId = $scope.activeEntry.entry._id;
					$state.go('.', {entryId: newEntryId}, {inherit: true, notify: false});
				  $scope.scrollToEntry(newEntryId);
			  }
		  });

		  /*********END inplace edit functions END*******/



		  $scope.convertActionsToArray = function(data) {
			  var returnData = [];

			  for (var name in data) {
				  returnData.push({
					  index: data[name],
					  name: name
				  });
			  }

			  return returnData;
		  };


        $scope.getSorted = function(mapEnum)
        {
          var asArray = [];
          Object.keys(mapEnum).forEach(function(key)
          {
            asArray[mapEnum[key]] = key;
          });
          return asArray;
        };

          $scope.selectEntries = function (selectType) {
              var selectFunction;
              switch (selectType) {
                  case $scope.selectTypeOptions.All:
                      selectFunction = function () {
                          return true;
                      };
                      break;
                  case $scope.selectTypeOptions.None:
                      selectFunction = function () {
                          return false;
                      };
                      break;
                  case $scope.selectTypeOptions.Untranslated:
                      selectFunction = function (entry) {
                          return entry.isUnTranslated;
                      };
                      break;
                  case $scope.selectTypeOptions['Drafts w/o translations']:
                      selectFunction = function (entry) {
                          return entry.hasDraft && !entry.isTranslated;
                      };
                      break;
                  case $scope.selectTypeOptions['Drafts w. translations']:
                      selectFunction = function (entry) {
                          return entry.hasDraft && entry.isTranslated;
                      };
                      break;
                  case $scope.selectTypeOptions.Translated:
                      selectFunction = function (entry) {
                          return entry.isTranslated;
                      };
                      break;
                  case $scope.selectTypeOptions.Locked:
                      selectFunction = function (entry) {
                          return entry.locked;
                      };
                      break;
              }

              var status = $scope.getUpdateEntriesStatusFn();
              for (var i = 0; i < $scope.viewList.length; i++) {
                  var entry = $scope.viewList[i];
                  var select = selectFunction(entry);
                  if (entry.selected !== select) {
                      entry.selected = select;
                  }
                  status(entry);
              }
              $scope.setAllEntryStatus(status);
          };


		  $scope.setEntryDependingOnState = function() {

				if ($stateParams.hasOwnProperty('entryId') && $stateParams.entryId) {
					var newIndex = $scope.getEntryIndex($stateParams.entryId);
					if (newIndex !== undefined) {
						$rootScope.$broadcast('liveEditEntrySelectIndex', {index: newIndex, direction: 'positive', id: $stateParams.entryId});
					}
				}

			};


		  $scope.setLayoutDependingOnState = function(fromState) {
			  	var currentStateName = $state.current.name;
				if (currentStateName.indexOf('viewLanguage') === 0) {
					$rootScope.fullWidthContainer = true;
				} else {
					$rootScope.fullWidthContainer = false;
				}

				var prevStatePart = null;
				if(fromState){
					prevStatePart = $scope.getCustomLastStatePart(fromState.name);
				}
				
				if ($state.current.views && $state.current.views.hasOwnProperty('sidecontent@viewLanguage') || 
				currentStateName.indexOf('tag') !== -1 || currentStateName.indexOf('file') !== -1) {
					// View which has sidecontent
					$('.side-content').removeClass('collapsed');
					$('.main-content').removeClass('extended');

					$scope.isSideBarMinimized = false;
					$rootScope.isLeftSideOpened = true;
					$scope.setLeftSideResizing();

					if(!$scope.onDestroyingView && $rootScope.isDetailViewOpened || 
					currentStateName.indexOf('tags.edit') !== -1 || currentStateName.indexOf('tags.new') !== -1 ||
					currentStateName.indexOf('files.edit') !== -1 || currentStateName.indexOf('files.new') !== -1 ||
					(currentStateName.indexOf('tag') !== -1 && currentStateName.indexOf('edit') !== -1) ||
					(currentStateName.indexOf('tag') !== -1 && currentStateName.indexOf('new') !== -1) ||
					(currentStateName.indexOf('file') !== -1 && currentStateName.indexOf('edit') !== -1) ||
					(currentStateName.indexOf('file') !== -1 && currentStateName.indexOf('new') !== -1)){
						if(!prevStatePart || currentStateName.indexOf('.edit') === -1 && currentStateName.indexOf('.new') === -1){
							// Setting the state if it's not set already
							switch (prevStatePart) {
								case 'edit':
										if(fromState.name.indexOf('.state') !== -1){
											$state.go('.state.edit', { entryId: $scope.entryId, stateName: fromState.params.stateName }, { inherit: true, notify: false });
										} else {
											$state.go('.edit', { entryId: $scope.entryId }, { inherit: true, notify: false });
										}
									break;
								case 'new':
										if(fromState.name.indexOf('.state') !== -1){
											$state.go('.state.new', { entryId: null, stateName: fromState.params.stateName }, { inherit: true, notify: false });
										} else {
											$state.go('.new', { entryId: null }, { inherit: true, notify: false });
										}
									break;
								case 'state':
									if(fromState.name.indexOf('.edit') !== -1){
										$state.go('.state.edit', { entryId: $scope.entryId, stateName: fromState.params.stateName }, { inherit: true, notify: false });
									} else if(fromState.name.indexOf('.new') !== -1){
										$state.go('.state.new', { entryId: null, stateName: fromState.params.stateName }, { inherit: true, notify: false });
									} else{
										$state.go('state', { stateName: fromState.params.stateName }, { inherit: true, notify: false });
									}
									break;
							} 
							$timeout(function(){
								$('display-tags[entry-id=\'' + $scope.entryId + '\']').parents('.list-group-item').addClass('detail-view-active');
							}, 450);
						} else {
							$scope.openDetailView($scope.entryIndex);
						}
						$scope.bothSidesOpened = true;
					} else {
						$scope.bothSidesOpened = false;
					}

					if(prevStatePart && prevStatePart === 'state'){
						$state.go('.state', { stateName: fromState.params.stateName }, { inherit: true, notify: false });
					}
				} else {
					// View which does NOT have sidecontent
					$('.side-content').addClass( 'collapsed' );
					$('.main-content').addClass( 'extended' );
					$scope.bothSidesOpened = false;
					$rootScope.isLeftSideOpened = false;
					$scope.isSideBarMinimized = false;
					$scope.setLeftSideResizing();

					if(!$scope.onDestroyingView && $rootScope.isDetailViewOpened && currentStateName.indexOf('.edit') === -1 && currentStateName.indexOf('.new') === -1){
						// Set the state it it is not set already
						switch (prevStatePart) {
							case 'edit':
									if(fromState.name.indexOf('.state') !== -1){
										$state.go('.state.edit', { entryId: $scope.entryId, stateName: fromState.params.stateName }, { inherit: true, notify: false });
									} else {
										$state.go('.edit', { entryId: $scope.entryId }, { inherit: true, notify: false });
									}
								break;
							case 'new':
									if(fromState.name.indexOf('.state') !== -1){
										$state.go('.state.new', { entryId: null, stateName: fromState.params.stateName }, { inherit: true, notify: false });
									} else {
										$state.go('.new', { entryId: null }, { inherit: true, notify: false });
									}
								break;
							case 'state':
								if(fromState.name.indexOf('.edit') !== -1){
									$state.go('.state.edit', { entryId: $scope.entryId, stateName: fromState.params.stateName }, { inherit: true, notify: false });
								} else if(fromState.name.indexOf('.new') !== -1){
									$state.go('.state.new', { entryId: null, stateName: fromState.params.stateName }, { inherit: true, notify: false });
								} else{
									$state.go('state', { stateName: fromState.params.stateName }, { inherit: true, notify: false });
								}
								break;
						}
						$timeout(function(){
							$('display-tags[entry-id=\'' + $scope.entryId + '\']').parents('.list-group-item').addClass('detail-view-active');
						}, 450);
					} else if(prevStatePart && currentStateName.indexOf('.edit') !== -1){
						var entryIndex = $scope.getEntryIndex($stateParams.entryId);
						$scope.openDetailView(entryIndex);
					} else if(currentStateName.indexOf('.') !== -1 && currentStateName.indexOf('.state') === -1 && prevStatePart && prevStatePart === 'state'){
						$state.go('.state', { stateName: fromState.params.stateName }, { inherit: true, notify: false });
					}
				}
			};

		  //$rootScope.$on('$stateChangeStart',
		  $rootScope.$on('$stateChangeSuccess',
			  function(event, toState, toParams, fromState, fromParams) {
				  if (toState.name === 'viewLanguage') {
					  // Nobody is allowed to use the parent route "viewLanguage"
					  // so we change automatically to the correct one
					  $state.go('viewLanguage.entry', {}, {inherit: true, notify: false});
				  }

				  if (fromState.name.indexOf('viewLanguage.entry') === 0) {
						// Re-load all values missing that weren't loaded for the single entry view
						$scope.updateEntryKeyMapData();

					  if (toState.name === 'viewLanguage.entry.tag' && toParams.hasOwnProperty('tagId')) {
							// We want to have a list filtered by tag
							$scope.updateViewList(true);
						} else if (toState.name === 'viewLanguage.entry.file' && toParams.hasOwnProperty('fileName')) {
							// We want to have a list filtered by fileName
							$scope.updateViewList(true);
					  } else if ((fromParams.hasOwnProperty('tagId') || fromParams.hasOwnProperty('fileName')) && ['viewLanguage.entry', 'viewLanguage.entry.tags', 'viewLanguage.entry.files'].indexOf(toState.name) !== -1) {
						  // We come from a list which was filtered by tag or fileName and want
							// now a complete one
						  $scope.updateViewList(true);
						}
					}
					
					if(toState.name.indexOf('file') !== -1 && fromState.name.indexOf('tag') || 
					toState.name.indexOf('tag') !== -1 && fromState.name.indexOf('file')){
						$scope.isLeftSideStillOpened = true;
					} else {
						$scope.isLeftSideStillOpened = false;
					}

				  // Keep the tagId and fileName up to date
				  $scope.tagId = toParams.tagId;
					$scope.filterFileName = toParams.fileName;
					if ($scope.filterFileName) {
						$scope.filterFileName = decodeURI($scope.filterFileName);
					}

				  if (toState.name.indexOf('viewLanguage.entry.tag') === 0) {
					  $scope.breadcrumbs.displayTags = true;
				  } else {
					  $scope.breadcrumbs.displayTags = false;
				  }

				  fromState.params = fromParams;
				  $scope.setLayoutDependingOnState(fromState);

				  $timeout(function() {
					  $scope.scrollToEntry($stateParams.entryId, 20, false);
					  if($rootScope.isDetailViewOpened){
						$scope.setPrevNextButtons();
					  }
				  }, 200);
			  }
			);
			
			$rootScope.$on('EntryDetailClosed',
			  function() {
					$scope.updateEntryKeyMapData();
			});

			/**
			 * When leaving view
			 */
			$scope.$on('$destroy' , function(event, toState, toParams, fromState, fromParams){
				$scope.onDestroyingView = true;
			});

			$scope.selectAllEntries = function (select) {
					$scope.selectEntries(select ? $scope.selectTypeOptions.All : $scope.selectTypeOptions.None);
			};

			$scope.hasUserGroupPermissions = function () {
				if(!$scope.userGroups.length){
					return true;
				}

				let permitted = false;
				let checkRoles = ['translator', 'manager', 'tpttranslator', 'tptservices'];

				if (checkRoles.includes($scope.roleInApp)) {
					let groupsMember = $scope.userGroups.filter(function (userGroup) { 
						return userGroup.members.some(function (m) { 
							return m.user === $scope.authentication.user._id; 
						});
					});

					if(!groupsMember.length){
						permitted = true;
					}
					
					groupsMember.forEach(function (userGroup) { 
						if(!permitted){
							permitted = userGroup.languages.some(function (userGroupLang) { 
								return userGroupLang.language === $scope.language.name; 
							});
						}
					});
				} else {
					permitted = true;
				}

				return permitted;
			};

		  $scope.actionPermitted = function(index)
		  {
			  if(!$scope.numEntriesSelected) return false;
			  var permitted = !$scope.lockedEntrySelected;
			  switch(index)
			  {
				  case $scope.actions.Publish:
					  permitted = permitted && $scope.mobileApp.permissions.can_edit_drafts &&
					  			  $scope.mobileApp.permissions.can_edit_translations && $scope.hasUserGroupPermissions(); 
					  break;
				  case $scope.actions['Clear draft']:
					  permitted = permitted && $scope.mobileApp.permissions.can_edit_drafts;
				      break;
				  case $scope.actions['Clear translation']:
					  permitted = permitted && $scope.mobileApp.permissions.can_edit_translations;
					  break;
				  case $scope.actions['Delete (all languages)']:
					  permitted = permitted && $scope.mobileApp.permissions.can_delete_translations;
						break;
				  case $scope.actions.Lock:
				  case $scope.actions['Lock (all languages)']:
				  case $scope.actions.Unlock:
				  case $scope.actions['Unlock (all languages)']:
				  case $scope.actions['Export selected']:
				  case $scope.actions['Add to Memory']:
					case $scope.actions['Translate from Memory']:
						permitted = true;
						break;
					case $scope.actions['Link (all duplicates)']:
						permitted = $scope.numEntriesSelected > 1;
						break;
					case $scope.actions.Unlink:
						permitted = $scope.linkedEntrySelected;
						break;
			  }
			  return permitted;
		  };


		  /**
		   * Returns all the currently selected entries
		   */
		  $scope.getSelectedEntries = function () {
			  if(!$scope.viewList || $scope.viewList.length === 0){
				return;
			  }
			  
			  return $scope.viewList.reduce(function (result, entry, index, viewlist) {
				  if (entry.selected) {

				        if(parseInt(entry.status) === 5) {
				            result.hasInOrderStatus = true;
                        }

						result.keys.push(entry.key);
						result.descIds.push(entry._id);
					  if ($scope.getEntryValue(entry.key)) {
						  result.valueIds.push($scope.getEntryValue(entry.key)._id);
						}
						if (entry.linkedKeys) {
							result.keys = result.keys.concat(entry.linkedKeys);
							for (var i = 0; i < entry.linkedKeys.length; i++) {
								if (EntryMain._getHiddenEntryDescIdByKey(entry.linkedKeys[i])) {
									result.descIds.push(EntryMain._getHiddenEntryDescIdByKey(entry.linkedKeys[i]));
								}
								if ($scope.getEntryValue(entry.linkedKeys[i])) {
									result.valueIds.push($scope.getEntryValue(entry.linkedKeys[i])._id);
								}
							}
						}
				  }
				  return result;
			  }, {
				  keys: [],
				  descIds: [],
				  valueIds: [],
                  hasInOrderStatus: false
			  });
		  };


			$scope.performAction = function (action) {
					$scope.showLoading(true);
					var success = function (response) {

				  if (action === $scope.actions['Delete (all languages)']) {
					  $rootScope.$broadcast('tagsChanged');
				  }

                  $rootScope.$broadcast('entriesChanged');

                  $scope.showLoading(false);
				  Utilities.showMessage('Success', '', 'success');
			  };
              var failure = function (errResponse) {
                  $scope.showLoading(false);
				  Utilities.showMessage('Warning', errResponse.data.message, 'warning');
			  };

            var selectedEntries = $scope.getSelectedEntries();
            var count = selectedEntries.descIds.length;

            if(!count) {
              $scope.showLoading(false);
				Utilities.showMessage('Warning', 'No Entries selected!', 'warning');
			}

			  if($scope.isAnyEditActive()){
				  $scope.activeEntry.key = undefined;
				  $scope.activeEntry.entry = undefined;
			  }

              var params =
              {
                  mobileAppId: $scope.mobileAppId,
                  languageId: $scope.languageId,
                  groupId: $scope.groupId,
                  entries: selectedEntries,
				  groupVersion : $scope.getGroupVersion()
              };
              switch (action) {
                  case $scope.actions.Lock:
                      MultiActionEntries.lock(
                        params, success, failure);
                      break;
                  case $scope.actions['Lock (all languages)']:
                      MultiActionEntries.lockAll(
                        params, success, failure);
                      break;
                  case $scope.actions.Unlock:
                      MultiActionEntries.unlock(
                        params, success, failure);
                      break;
                  case $scope.actions['Unlock (all languages)']:
                      MultiActionEntries.unlockAll(
                        params, success, failure);
                      break;
                  case $scope.actions.Publish:
                      MultiActionEntries.publish(
                        params, success, failure);
                      break;
                  case $scope.actions['Clear draft']:
                      MultiActionEntries.clearDraft(
                        params, success, failure);
                      break;
                  case $scope.actions['Clear translation']:
                      MultiActionEntries.clearValue(
                        params, success, failure);
                      break;
                  case $scope.actions['Delete (all languages)']:
                    $scope.showLoading(false);
                    $scope.openDeleteSelectedModal(count, function(confirmed)
                    {
                      if(confirmed)
                      {
                        $scope.showLoading(true);
                        MultiActionEntries.delete(
                          params, success, failure);
                      }
                    });
                      break;
								case $scope.actions['Export selected']:
									$scope.showLoading(false);
									$scope.exportToFile();
									break;
								case $scope.actions['Add to Memory']:
									$scope.addToTm();
									break;
								case $scope.actions['Translate from Memory']:
									$scope.autotranslateFromTm();
									break;
								case $scope.actions['Link (all duplicates)']:
									MultiActionEntries.link(params, success, failure);
									break;
								case $scope.actions.Unlink:
									MultiActionEntries.unlink(params, success, failure);
									break;
              }
          };


          $scope.trimString = function (text, maxLength) {
              if (typeof text === 'undefined') return '';
              if (typeof maxLength === 'undefined') {
                  maxLength = 36;
              }
              var result = text;
              var dots = '...';
              if (text.length > maxLength) {
                  result = text.slice(0, maxLength - 1 - dots.length) + dots;
              }
              return result;
          };

        $scope.debouncedTriggerSearch = _.debounce(function() {
          $timeout(function () {
            $scope.updateViewList();
            $scope.showProcessing(false);
          }, 50);
        }, 1000);



		  /**
		   * Custom sort function which groups array- & plural-values together
		   */
		  $scope.propertySort = function(propertyName, fullData, reverseSortOrder) {
			  // REMEMBER: Always return strings, never numbers else it will
			  //           mess up the sorting.

			  var sortPropertyData = $scope.getSortOrderData(propertyName);

			  // Depending on how the property sortswe assign a very high or
			  // low value to have entries which do not have the given value
			  // sorted after all other ones by default.
			  var defaultValue = 'ZZZZZZZZZZZZZZZZZZZ';
			  if (sortPropertyData.hasOwnProperty('reverse') && sortPropertyData.reverse === true) {
				  defaultValue = '                   ';
			  }

			  // The actual function with returns the value to sort
			  return function(entry) {
				  var returnValue;

				  if (entry.hasOwnProperty('_sortIndex')) {

					  //var returnValue = entry._sortKey || entry.key;
					  if (propertyName === 'key') {
						  // If sorted by key, simply get the sortKey. The
						  // index will get added later
						  returnValue = entry._sortKey;
					  } else if (['_id', 'draft', 'baseValue', 'value', 'valueUpdatedAt'].indexOf(propertyName) !== -1) {
						  returnValue = EntryMain._getArrayEntriesValue(entry._sortKey, propertyName, defaultValue);
					  }

					  // To make sure that the entry with the lowest index is
					  // always first no matter in which direction we sort
					  var sortIndex = entry._sortIndex;
					  if (reverseSortOrder) {
						  sortIndex = 9999 - sortIndex;
					  }

					  // Add the index to the string so that they get sorted
					  // correctly
					  returnValue += '    ';

					  returnValue = returnValue.slice(0, -1*(sortIndex.toString().length));
					  returnValue += sortIndex;
				  } else {
					  // The entry does not have an index so we simply return
					  // the value as is.

					  // Check if the entry has the needed property
					  if (!entry[propertyName]) {
						  // Entry does not have value for the property
						  returnValue = defaultValue;
					  } else {
						  // Entry has a value for the needed property
						  returnValue = entry[propertyName];

						  if (propertyName === 'valueUpdatedAt') {
							  // Create a milliseconds-time from date
							  returnValue = new Date(returnValue).getTime().toString();
						  } else if (propertyName === '_id') {
							  // Create a milliseconds-time from MongoDB-id
							  returnValue = new Date(parseInt(returnValue.substring(0, 8), 16) * 1000).getTime().toString();
						  }
					  }
				  }

				  return returnValue;
			  };
		  };


			/**
			 * Returns the full entries for the given keys
			 */
			$scope.getEntriesByKey = function (keys, groupId) {
				var entryKeys = keys.slice();

				var returnData = [];
				// Find all the entries of the tag
				if (entryKeys.length !== 0) {
					var allEntries = EntryMain._getGroupEntries(groupId);

					for (var i = 0; i < allEntries.length; i++) {
						var entry = allEntries[i];
						var keysToCheck, keyFound;

						// Check if the key is linked to any other key
						if (entry.linkedKeys) {
							keysToCheck = [ entry.key ];
							keysToCheck = keysToCheck.concat(entry.linkedKeys);
						}
						else {
							keysToCheck = [ entry.key ];
						}

						keyFound = false;
						for (var j = 0; j < keysToCheck.length; j++) {
							if (entryKeys.indexOf(keysToCheck[j]) !== -1) {	
								keyFound = true;
								break;
							}
						}

						if (keyFound) {
							// Add entry to list
							returnData.push(entry);

							// Remove the found key
							var keyIndex = entryKeys.indexOf(entry.key);
							entryKeys.splice(keyIndex, 1);

							// Check if we found already all the entries
							// of the tag
							if (entryKeys.length === 0) {
								// If we found all the keys we need stop
								break;
							}
						}
					}
				}

				return returnData;
			};


			/**
		   * Returns all the entries with the given file name
		   */
			$scope.getEntryByFileName = function (fileName, groupId, callback) {
				FileMain.getFiles($scope.mobileAppId, groupId, $scope.languageId)
					.then(
						function(data) {

							var entryKeys = [];
							if (data.files.hasOwnProperty(fileName)) {
								entryKeys = data.files[fileName];
							}

							callback(null, $scope.getEntriesByKey(entryKeys, groupId));
						}
					)
					.catch(
						function(error) {
							callback(error);
						}
					);
			};


		  /**
		   * Returns all the entries of a tag
		   */
		  $scope.getEntryByTag = function(tagId, groupId, callback) {
			  TagMain.getTag(tagId, true, function(err, tag) {
				  if (err) {
					  return callback(err);
				  }


                  var entryKeys = _.union(tag.languageEntryIds, tag.automaticLanguageEntryIds, tag.fuzzyLanguageEntryIds);
				  callback(null, $scope.getEntriesByKey(entryKeys, groupId));
			  });
		  };



			$scope.searchChanged = function () {
				$scope.showProcessing(true);
				$scope.debouncedTriggerSearch();
			};



		  $scope.sortEntries = function(targetList) {
			  // Get if the properties should get sorted ASC or DESC
			  var reverseSortOrder = $scope.sorting.orderDesc;

			  // The sorting of some properties have to get reversed so we check
			  // if the current property we sort for is one of them.
			  var sortPropertyData = $scope.getSortOrderData($scope.sorting.property);
			  if (sortPropertyData.hasOwnProperty('reverse') && sortPropertyData.reverse === true) {
				  reverseSortOrder = !reverseSortOrder;
			  }

			  // Now sort the entries depending on the what the user has defined
			  //targetList = $filter('orderBy')(targetList, $scope.sorting.property, reverseSortOrder);
			  return $filter('orderBy')(targetList, $scope.propertySort($scope.sorting.property, targetList, reverseSortOrder), reverseSortOrder);
		  };


		  /**
		   * Gets the filter query for the currently active filters
		   */
		  $scope.getFilterQuery = function() {

			  var filterQuery = {};

			  if ($scope.filtering.property.indexOf('customFilter') === 0) {
				  filterQuery = $scope.filtering.customFilters;
			  } else {
				  var filteringData = $scope.getFilteringData($scope.filtering.property);
				  filterQuery = angular.copy(filteringData.filter);
			  }

			  if ($scope.filtering.searchText) {
				  // If there is any text in the search-field filter
				  // additionally by it
				  filterQuery = $scope.addToFilterToQuery(filterQuery, {
					  _join: 'OR',
					  _text: true,
					  draft: $scope.filtering.searchText,
					  value: $scope.filtering.searchText,
					  baseValue: $scope.filtering.searchText,
						key: $scope.filtering.searchText,
						linkedKeys: $scope.filtering.searchText
				  });
			  }

			  if (filterQuery === undefined) {
				  // Be sure to never return undefined because that would cause
				  // problems down the line.
				  filterQuery = {};
			  }

			  return filterQuery;
		  };


			/**
			 * Checks if a filter query contains a value for a specific field
			 * @param filter The filter to check
			 * @param fieldName The field name to check for
             * @returns {boolean}
             */
			$scope.doesFilterContainField = function(filter, fieldName) {
				if(filter.hasOwnProperty(fieldName)) {
					return true;
				}

				if(filter.hasOwnProperty('terms')) {
					for (var i=0;i<filter.terms.length;i++) {
						var filterTerm = filter.terms[i];
						if ($scope.doesFilterContainField(filterTerm, fieldName)) {
							return true;
						}
					}
				}

				return false;
			};

		  /**
		   * Applies the currently active filters to the given entries
		   */
		  $scope.applyFilters = function(entries) {
			  var filterQuery = $scope.getFilterQuery();
				$scope.filtering.oldFilterQuery = angular.copy(filterQuery);
				
			  // The values for the issues is not on the entry by default
			  // and has to be created on the fly. So we set the values now
			  // before the filter gets applied. We can not do it only:
			  // once on load because it is different for each language
			  // and creating it always for all languages would be a waist.

			  // Define what checks should run for which issue filter
			  var issueCheckFunctions = {
				  hasIssues: {
					  'draft': [
						  EntryWarnings.checkFunctions.maxLengthCheckFunction,
						  EntryWarnings.checkFunctions.variableMissingCheckFunction,
						  EntryWarnings.checkFunctions.glossaryCheckFunction
					  ],
					  'source': [
						  EntryWarnings.checkFunctions.sourceStringChangedCheckFunction
					  ],
					  'target': [
						  EntryWarnings.checkFunctions.maxLengthCheckFunction,
						  EntryWarnings.checkFunctions.variableMissingCheckFunction,
						  EntryWarnings.checkFunctions.glossaryCheckFunction
					  ]
				  },
				  hasIssuesVariableMissing: {
					  draft: [
						  EntryWarnings.checkFunctions.variableMissingCheckFunction
					  ],
					  target: [
						  EntryWarnings.checkFunctions.variableMissingCheckFunction
					  ]
				  },
				  hasIssuesToLong: {
					  draft: [
						  EntryWarnings.checkFunctions.maxLengthCheckFunction
					  ],
					  target: [
						  EntryWarnings.checkFunctions.maxLengthCheckFunction
					  ]
				  },
				  hasIssuesGlossaryTermMissing: {
					  draft: [
						  EntryWarnings.checkFunctions.glossaryCheckFunction
					  ],
					  target: [
						  EntryWarnings.checkFunctions.glossaryCheckFunction
					  ]
				  },
				  hasIssuesSourceChanged: {
					  source: [
						  EntryWarnings.checkFunctions.sourceStringChangedCheckFunction
					  ]
				  }
			  };

			  // Check if we currently filter for any of the issues and if so
			  // add the property accordingly
			  let entry, i, index;
			  for (let fieldName in issueCheckFunctions) {
				  if ($scope.doesFilterContainField(filterQuery, fieldName)) {

					  let warningFields = Object.keys(issueCheckFunctions[fieldName]);

					  for (i=0;i<entries.length;i++) {
						  entry = entries[i];
						  // Data for the check-functions
						  let data = {
							  base: {
								  value: entry.baseValue,
								  valueUpdatedAt: entry.baseValueUpdatedAt
							  },
							  languages: {
								  base: $scope.mobileApp.baseLanguage,
								  entry: $scope.language.name
							  },
							  entry: entry,
							  isMasterLang: $scope.isMasterLang
						  };
						  let warnings = EntryWarnings.runCheckFunctions(warningFields, data, issueCheckFunctions[fieldName]);
						  entry[fieldName] = warnings.length !== 0;
					  }
				  }
				}
				
				//Metadata filter check
				if ($scope.doesFilterContainField(filterQuery, 'metadata')){
					var metadataFilter;
					var entriesFiltered = [];

					if(filterQuery.hasOwnProperty('metadata')) {
						metadataFilter = angular.copy(filterQuery.metadata);
						delete filterQuery.metadata;
					} else if(filterQuery.hasOwnProperty('terms')) {
						for (var t=0;t<filterQuery.terms.length;t++) {
							var filterTerm = filterQuery.terms[t];
							if ($scope.doesFilterContainField(filterTerm, 'metadata')) {
								metadataFilter = angular.copy(filterTerm.metadata);
								delete filterQuery.terms[t].metadata;
							}
						}
					}
				
					switch(metadataFilter.operator){
						case 'Contains':
							entriesFiltered = entries.filter(function(item){ 
								if(item.metadata){
									return item.metadata.some(function(m){
										if(m.value) {
												if(metadataFilter.key === 'Any')
													return m.value.toLowerCase().includes(metadataFilter.value.toLowerCase());
												else 
													return m.key === metadataFilter.key && m.value.toLowerCase().includes(metadataFilter.value.toLowerCase());
										} else 
												return false;
									}); 
								} else 
										return false;
							});
						break;
						case 'Does not contain':
						entriesFiltered = entries.filter(function(item){
							if(item.metadata){ 
								return item.metadata.some(function(m){
									if(m.value) {
											if(metadataFilter.key === 'Any')
												return !m.value.toLowerCase().includes(metadataFilter.value.toLowerCase());
											else 
												return m.key === metadataFilter.key && !m.value.toLowerCase().includes(metadataFilter.value.toLowerCase());
									} else 
											return false;
								}); 
							} else
									return false;
						});
						break;
						case 'Equals':
							entriesFiltered = entries.filter(function(item){ 
								if(item.metadata){
									return item.metadata.some(function(m){
										if(m.value) {
												if(metadataFilter.key === 'Any')
													return m.value === metadataFilter.value;
												else 
													return m.key === metadataFilter.key && m.value === metadataFilter.value;
										} else 
												return false;
									}); 
								} else 
										return false;
							});
						break;
						case 'Does not equal':
							entriesFiltered = entries.filter(function(item){ 
								if(item.metadata){
									return item.metadata.some(function(m){
										if(m.value) {
												if(metadataFilter.key === 'Any')
													return m.value !== metadataFilter.value;
												else 
													return m.key === metadataFilter.key && m.value !== metadataFilter.value;
										} else 
												return false;
									}); 
								} else 
										return false;
							});
						break;
						case 'Has any value':
							entriesFiltered = entries.filter(function(item){ 
								if(item.metadata){
									return item.metadata.some(function(m){
										if(metadataFilter.key === 'Any')
											return !!m.value;
										else 
											return m.key === metadataFilter.key && !!m.value;
									}); 
								} else 
										return false;
							});
						break;
						case 'Has no value':
						if(metadataFilter.key === 'Any'){
							$scope.mobileApp.metadata.forEach(function(mBone){
								entries.forEach(function(item){
									var itemFound;
									if(item.metadata)
										itemFound = item.metadata.find(function(m){ return m.key === mBone.fieldName; });
									if((!itemFound || !itemFound.value) && entriesFiltered.indexOf(item) < 0)
										entriesFiltered.push(item);
								});
							});
						} else {
							entriesFiltered = entries.filter(function(item){
									if(item.metadata) 
										return !item.metadata.find(function(m){ return m.key === metadataFilter.key && m.value; });
									else 
										return false;
							});
						}
						break;
					}
					
					entries = entriesFiltered;
				}

			  if ($scope.doesFilterContainField(filterQuery, 'draftValueDiffer')) {
					for (i=0;i<entries.length;i++) {
						entry = entries[i];
					  if (entry.draft && entry.value && entry.draft !== entry.value) {
							entry.draftValueDiffer = true;
					  } else {
							entry.draftValueDiffer = false;
					  }
				  }
				}
				
				if ($scope.doesFilterContainField(filterQuery, 'idSourceDiffer')) {
				  for (i=0;i<entries.length;i++) {
					  entry = entries[i];
					  if (entry.key && entry.sourceValue && entry.key !== entry.sourceValue || !entry.key || !entry.sourceValue) {
						  entry.idSourceDiffer = true;
					  } else {
						  entry.idSourceDiffer = false;
					  }
				  }
			  }

			  // Add date for the dupliciate-filter which gets also used by
			  // the inconsistent-filter
			  if ($scope.doesFilterContainField(filterQuery, 'isDuplicate') || $scope.doesFilterContainField(filterQuery, 'isInconsitent')) {
				  var previousValues = {};
				  for (i=0;i<entries.length;i++) {
						entry = entries[i];
						if($scope.isMasterLang){
							if (entry.value && previousValues.hasOwnProperty(entry.value)) {
								// Set the current entry as duplicate
								entry.isDuplicate = true;
								// Set the previously found entry as duplicate
								entries[previousValues[entry.value]].isDuplicate = true;
							} else {
								previousValues[entry.value] = i;
								entry.isDuplicate = false;
							}
						} else if (entry.baseValue && (entry.value || entry.draft)) {
							if(previousValues.hasOwnProperty(entry.baseValue)){
								// Set the current entry as duplicate
								entry.isDuplicate = true;
								// Set the previously found entry as duplicate
								entries[previousValues[entry.baseValue]].isDuplicate = true;
							} else {
								previousValues[entry.baseValue] = i;
								entry.isDuplicate = false;
							}
						} 
				  }
			  }

			  // Add data for inconsistent filter
			  if ($scope.doesFilterContainField(filterQuery, 'isInconsitent')) {
				  var duplicateEntries = {};
				  for (i=0;i<entries.length;i++) {
					  entry = entries[i];
					  entry.isInconsitent = false;
					  // The duplicate entries got already marked as such so
					  // we just have a look at them
					  if (entry.isDuplicate === true) {
						  if (duplicateEntries.hasOwnProperty(entry.baseValue)) {
							  // Entry with that base translation has been saved before.
							  // Add the index of the entry no matter what because
							  // we need the index for all entries with that translation.
							  duplicateEntries[entry.baseValue].indexes.push(i);

							  if (duplicateEntries[entry.baseValue].inconsistent === true) {
								  // If that base translation got marked already
								  // as inconsitent before there is no need to
								  // check again and directly go on.
								  continue;
							  }

							  // Check if the translation is identical
							  if (duplicateEntries[entry.baseValue].translation !== entry.value) {
								// Translations are not identical so mark as inconsistent
								duplicateEntries[entry.baseValue].inconsistent = true;
							  }
						  } else {
							  // Did not get added before so add the default entry
							  duplicateEntries[entry.baseValue] = {
								  inconsistent: false,
								  indexes: [ i ],
								  translation: entry.value
							  };
						  }
					  }
					}

				  // Now go through the translations which got marked as
				  // inconsitent mark all the entries with the same base
				  // language translation
				  for (var key in duplicateEntries) {
					  if (duplicateEntries[key].inconsistent === true) {
						  for (i in duplicateEntries[key].indexes) {
							index = duplicateEntries[key].indexes[i];
						  	entries[index].isInconsitent = true;
						  }
					  }
					}
			  }

			  // tag categories filter
			  if ($scope.doesFilterContainField(filterQuery, 'tagCategory')) {
				var filteredTags = [];
				$rootScope.tagFilterApplied = true;
				Object.keys($scope.tags).forEach(function(tag){
					if($scope.tags[tag].category === filterQuery.tagCategory){
						filteredTags.push(tag);
					}
				});
				return entries.filter(function(entry){
					return filteredTags.some(function(tag){
						return entry._tags.includes(tag);
					});
				});
			  } else if($scope.doesFilterContainField(filterQuery, 'noTags')){
					$rootScope.tagFilterApplied = true;
					return entries.filter(function(entry){
						return !entry._tags || !entry._tags.length;
					});
			  } else {
				$rootScope.tagFilterApplied = false;
				return window.SEARCHJS.matchArray(entries, filterQuery);
			  }
		  };


		  /**
		   * Adds an additional filter to an existing filter-query
		   * @param filterQuery The exsting query to add filter to
		   * @param addFilter the filter to add
		   * @returns {*}
		   */
		  $scope.addToFilterToQuery = function(filterQuery, addFilter) {
			  if (!filterQuery || Object.keys(filterQuery).length === 0) {
				  // If the current filter is empty we can simply return the new one
				  return addFilter;
			  }

			  if (filterQuery.hasOwnProperty('_join') && filterQuery._join === 'AND') {
				  filterQuery.terms.push(addFilter);
			  } else {
				  filterQuery = {
					  _join: 'AND',
					  terms: [
						  addFilter,
						  filterQuery
					  ]
				  };
			  }

			  return filterQuery;
		  };


		  /**
		   * Opens a modal to set custom filters
		   */
		  $scope.openCustomFilterModal = function(emptyFilter, previousFilter) {
				var loadData = {
					activeFilterKey: $scope.filtering.activeFilter,
					appId: $stateParams.mobileAppId,
					emptyFilter: emptyFilter,
					previousFilters: $scope.filtering.previousCustomFilterValues,
				};

			  var modalInstance = $modal.open({
				  templateUrl: 'modules/mobile-apps/views/custom-filter-modal.client.view.html',
				  controller: 'CustomFilterModalController',
				  size: 'md',
				  resolve: {
					  ModalInputData: function() {
					  	return loadData;
					  }
				  }
			  });

			  modalInstance.result.then(function (data) {
				  // Update all the different filter options because they may
				  // got changed
				  $scope.updateFilterOptions();

				  if (data.activeFilterKey) {
					  // If a saved filter is active set the filter as active
					  $scope.filtering.property = 'customFilter.' + data.activeFilterKey;
					  $scope.filtering.activeFilter = data.activeFilterKey;
				  } else {
					  $scope.filtering.property = 'customFilter.__current__';
					  $scope.filtering.activeFilter = undefined;
				  }

				  $scope.applyFilterValues(data.filterValues);
			  }, function() {
				  // User did not change anything so reset the previously
				  // selected filter
				  $scope.filtering.property = previousFilter;

				  $scope.updateFilterOptions();
			  });
		  };


		  $scope.applyFilterValues = function(filterValues) {
			  var filter = EntryMain.convertToFilterQuery(filterValues);

			  if (Object.keys(filter).length === 0) {
				  // If the filter is empty we set it to "all"
				  $scope.changeFiltering('all');
				  return;
			  }

			  $scope.filtering.customFilters = filter;
			  $scope.filtering.previousCustomFilterValues = filterValues;

			  $scope.updateViewList();
		  };


		  /**
		   * Update the entries in the list according to the current filter and
		   * sort settings
		   */
			$scope.updateViewList = function (refreshData) {
			  var currentTag = null;
			  var currentFileName = null;
			  var currentStateName = $state.current.name;
			  
				if ((currentStateName === 'viewLanguage.entry.tag' || currentStateName === 'viewLanguage.entry.tag.edit' || currentStateName === 'viewLanguage.entry.tag.new') && 
				$stateParams.hasOwnProperty('tagId') && $stateParams.tagId) {
				  currentTag = $stateParams.tagId;
			  }
				if ((currentStateName === 'viewLanguage.entry.file' || currentStateName === 'viewLanguage.entry.file.edit' || currentStateName === 'viewLanguage.entry.file.new') &&
				 $stateParams.hasOwnProperty('fileName') && $stateParams.fileName) {
					currentFileName = decodeURI($stateParams.fileName);
				}

			  // Check if the data needs to get refreshed
			  if (!refreshData) {
				  var filterQuery = $scope.getFilterQuery();
				  refreshData = !angular.equals($scope.filtering.oldFilterQuery, filterQuery);
			  }
			  if (!refreshData) {
				  refreshData = (currentTag !== $scope.filtering.oldTag);
			  }
				if (!refreshData) {
					refreshData = (currentFileName !== $scope.filtering.oldFileName);
				}

			  // Callback function to process the data to be able to get
			  // data async
			  var processDataCallback = function(err, targetList) {
				  if (err) {
					  return;
				  }

				  // Sort the entries according to current settings
					targetList = $scope.sortEntries(targetList);
					var stateParts = currentStateName.split('.');
					var lastStatePart = stateParts[stateParts.length-1];

				  // Set the status field accordingly
				  var status = $scope.getUpdateEntriesStatusFn();
				  for (let index = 0; index < targetList.length; index++) {
					  status(targetList[index]);
				  }
				  
					$scope.setAllEntryStatus(status);
					$scope.viewList = null;

					// Set the data to be displayed
					$timeout(function(){
						$scope.viewList = targetList;	

						// Update the counts
						$scope.calculateCounts();

						$rootScope.$broadcast('viewListUpdated');
	
						if ($scope.pageData.dataSource && $scope.pageData.dataSource.reload) {
							$scope.pageData.dataSource.reload(0);
						}
	
						if($scope){
							if (lastStatePart === 'edit' && $stateParams && $stateParams.entryId) {
									var entryIndex = $scope.getEntryIndex($stateParams.entryId);
									$rootScope.$broadcast('openDetailView', $scope.mobileAppId, $scope.languageId, $scope.groupId, $stateParams.entryId, entryIndex);
							} else if (lastStatePart === 'new') {
								$scope.openDetailView();
							}
						}
					}, 10);
			  };

			  $scope.noResultText = $scope.noResultTexts.default;
			  if (refreshData) {
				  if (currentTag !== null) {
					  $scope.noResultText = $scope.noResultTexts.tag;
					  $scope.filtering.oldTag = currentTag;
					  $scope.getEntryByTag($stateParams.tagId, $scope.groupId, function(err, entries) {
						  if (err) {
							  return;
							}
						  processDataCallback(null, $scope.applyFilters(entries));
					  });
					} else if (currentFileName !== null) {
						$scope.noResultText = $scope.noResultTexts.fileName;
						$scope.filtering.oldFileName = currentFileName;
						$scope.getEntryByFileName(currentFileName, $scope.groupId, function (err, entries) {
							if (err) {
								return;
							}
							processDataCallback(null, $scope.applyFilters(entries));
						});
					} else {
						var entries = $scope.applyFilters($scope.entryKeyMap[$scope.groupId]);
					  processDataCallback(null, entries);
				  }
			  } else {
				  // Data did not change so no need to apply filter
				  processDataCallback(null, $scope.viewList);
			  }

			  setTimeout(function(){
				if($stateParams.hasOwnProperty('entryId') && $stateParams.entryId) {
					$scope.scrollToEntry($stateParams.entryId);
				  }
			  }, 150);
			};

          /*
           * helper function which makes it possible to get a function and store variables on it, without knowing the original named function,
           * creates a new function instance as well, resetting the stored variables everytime u get the function
           */
          $scope.y = function (f) {
              var fn = function () {
                  return f.bind(null, fn).apply(this, arguments);
              };
              return fn;
          };

          /*
           gets the function for usage, its done this way to reinitialize any function variables,
           and make it possible to store them in the function no matter what we call it
           */
          $scope.getUpdateEntriesStatusFn = function () {
              return $scope.y(function (fnRef, entry) {
                  /*if (fnRef.done) {
                      return;
                  }*/
                  var entrySelected = entry.selected || false;
                  //console.log('entry selected : '+entrySelected);

                  if (entry.selected)
                  {
                    if (typeof fnRef.selectedCount === 'undefined') fnRef.selectedCount = 0;
                    fnRef.selectedCount++;
                    //console.log('statusLocked : '+fnRef.statusLocked+' - entry locked : '+entry.locked);
                    if (fnRef.statusLocked !== true && entry.locked )
                    {
                      fnRef.statusLocked = true;
										}

										if (fnRef.statusLinked !== true && entry.link) {
											fnRef.statusLinked = true;
										}
                  }

                  if (typeof fnRef.status === 'undefined') {
                      fnRef.status = entrySelected;
                      return;
                  } else if (entrySelected !== fnRef.status) {
                      //console.log('indeterminate : '+true);
                      fnRef.statusIndeterminate = true;
                      //fnRef.done = true;
                      return;
                  }
              });
          };

          $scope.setAllEntryStatus = function (status) {
              //the order can make a difference, $scope.allEntriesSelected or $scope.allEntriesSelectedIndeterminate set first

            $scope.numEntriesSelected = status.selectedCount || 0;
						$scope.lockedEntrySelected = status.statusLocked || false;
						$scope.linkedEntrySelected = status.statusLinked || false;
            //console.log('setAllEntryStatus locked: '+status.statusLocked);

            //console.log('setAllEntryStatus count: '+status.selectedCount);
              if (status.statusIndeterminate) {
                  if (!$scope.allEntriesSelected) {
                      $scope.allEntriesSelected = true;
                  }
                  if (!$scope.allEntriesSelectedIndeterminate) {
                      $scope.allEntriesSelectedIndeterminate = status.statusIndeterminate;
                  }
              } else {
                  if (status.status !== $scope.allEntriesSelected) {
                      $scope.allEntriesSelected = status.status;
                  }
                  if ($scope.allEntriesSelectedIndeterminate) {
                      $scope.allEntriesSelectedIndeterminate = false;
                  }
              }
          };

          $scope.getCurrentGroup = function () {
			  if ($stateParams.hasOwnProperty('groupId') && $stateParams.groupId) {
				  return $stateParams.groupId;
			  } else if ($scope.mobileApp.groupsEnabled && $scope.authentication.user.lastGroupId && $scope.authentication.user.lastGroupId[$scope.mobileAppId]) {
                  return $scope.authentication.user.lastGroupId[$scope.mobileAppId];
              }

			  return null;
          };

          $scope.storeCurrentGroup = function (groupId) {
              if (!$scope.authentication.user.lastGroupId) {
                  $scope.authentication.user.lastGroupId = {};
              }
              $scope.authentication.user.lastGroupId[$scope.mobileApp._id] = groupId;
          };


          $scope.getCurrentRoleInApp = function () {
              var team = $scope.mobileApp.team;
              var userId = $scope.authentication.user._id;
              for (var i = 0; i < team.members.length; i++) {
                  if (userId === team.members[i].user) {
                      $scope.roleInApp = team.members[i].role;
                  }
              }
          };

          $scope.openManageGroups = function () {
              $state.go('listGroups', {
                  mobileAppId: $scope.mobileApp._id
              });
          };

          /**
           * Refresh the page.
           *
           * @param mobileAppId
           * @param languageId
           */
          $scope.redirectToMobileAppLanguages = function (mobileAppId, languageId) {
              $location.path('projects/' + mobileAppId + '/languages/' + languageId);
          };


          // approve all existing Language entries
          $scope.approveAll = function (event) {
              event.preventDefault();

              $scope.showLoading(false);
              ApproveAllLanguageEntries.approve({
                  mobileAppId: $stateParams.mobileAppId,
                  languageId: $stateParams.languageId,
                  groupId: $scope.groupId
              }, function (response) {

                  $scope.groupLanguageEntryMap[$scope.groupId][$scope.language._id] = response;
                  $scope.updateEntryKeyMapData();
                  $scope.showLoading(false);
                  $rootScope.$broadcast('entriesChangedSuccess');
              }, function (errorResponse) {
                  $scope.error = errorResponse.data.message;
                  $scope.showLoading(false);
              });
          };

          $scope.showLoading = function (loading) {
              var loaded = !loading;
              if ($scope.loadedStatus !== loaded) {
                  $scope.loadedStatus = loaded;
              }
          };
          $scope.showProcessing = function (processing) {
              if ($scope.processingEntries !== processing) {
                  $scope.processingEntries = processing;
              }
          };

			  $scope.getGroupVersion = function(groupId){
				  groupId = groupId || $scope.groupId;
				  if(!$scope.groupLanguageEntryMap[groupId] || !$scope.groupLanguageEntryMap[groupId][$scope.languageId]){
					  return -1;
				  }
				  return $scope.groupLanguageEntryMap[$scope.groupId][$scope.languageId].version;
			  };

			  // Returns the index of the entry with the given key
			  $scope.getEntryIndex = function(id){
				  if (!angular.isArray($scope.viewList) || !$scope.entryKeyMap || !$scope.entryKeyMap.length || !$scope.entryKeyMap[$scope.groupId]) {
					  return undefined;
				  }
				  for (var i=0;i<$scope.viewList.length;i++) {
					  if ($scope.viewList[i]._id === id) {
						  return i;
					  }
				  }
				  var entryIndex = $scope.entryKeyMap[$scope.groupId].findIndex(function(item){ return item._id === id; });
				  if(entryIndex >= 0){
					  return entryIndex;
				  }

				  return undefined;
				};

				// Returns the index of the entry with the given key
				$scope.getEntryIndexByKey = function(key){
					if (!angular.isArray($scope.viewList)) {
						return undefined;
					}

					for (var i=0;i<$scope.viewList.length;i++) {
						if ($scope.viewList[i].key === key || ($scope.viewList[i].linkedKeys && $scope.viewList[i].linkedKeys.includes(key))) {
							return i;
						}
					}
					return undefined;
				};

			  $scope.getEntryValue = function(key, language){
				  language = language || $scope.languageId;
				  if(!$scope.groupLanguageEntryMap[$scope.groupId] || !$scope.groupLanguageEntryMap[$scope.groupId][language]){
					  return null;
				  }
				  return $scope.groupLanguageEntryMap[$scope.groupId][language].values[key];
			  };
			  $scope.setEntryValue = function(key, entryValueData, language){
				  // Reset cache that it will display the entry at the correct location
				  EntryMain.resetCachedSortValues(key);

				  language = language || $scope.languageId;
				  if(!$scope.groupLanguageEntryMap[$scope.groupId] || !$scope.groupLanguageEntryMap[$scope.groupId][language]){
					  return null;
				  }

				  let status = null;
				  if(entryValueData.status){
					status = entryValueData.status;
				  } else if($scope.groupLanguageEntryMap[$scope.groupId] && 
					$scope.groupLanguageEntryMap[$scope.groupId][language] &&
					$scope.groupLanguageEntryMap[$scope.groupId][language].values &&
					$scope.groupLanguageEntryMap[$scope.groupId][language].values[key]) {
					status = $scope.groupLanguageEntryMap[$scope.groupId][language].values[key].status;
				  }

				  var entryValue =
				  {
					  key : entryValueData.key,
					  draft : entryValueData.draft,
					  value : entryValueData.value,
                      status: status,
					  locked : entryValueData.locked,
						updatedAt : entryValueData.valueUpdatedAt || entryValueData.updatedAt,
						user: entryValueData.valueUser,
					  _id : entryValueData.valueId
				  };

				  $scope.groupLanguageEntryMap[$scope.groupId][language].values[key] = entryValue;

				  return $scope.groupLanguageEntryMap[$scope.groupId][language].values[key];
			  };

          $scope.updateEntryKeyData = function (entry, entryValue) {

			  entry.baseValue = '';
			  entry.sourceValue = '';
			  entry.valueCreatedAt = '';
			  entry.valueCreatedAtTime = 0;

              if (entryValue) {
                  if (entryValue.hasOwnProperty('locked')) {
                      entry.locked = entryValue.locked;
                  }
                  entry.isTranslated = !_.isEmpty(entryValue.value) && !entry.locked;
                  entry.hasDraft = !_.isEmpty(entryValue.draft) && !entry.locked;
                  entry.isUnTranslated = !(entry.isTranslated || entry.hasDraft) && !entry.locked;
                  entry.value = entryValue.value;
                  entry.draft = entryValue.draft;
                  entry.status = entryValue.status;
									entry.comment = entryValue.comment;
				  entry.valueUser = entryValue.user;
				  entry.valueUpdatedAt = entryValue.updatedAt;
				  if (entryValue.hasOwnProperty('maxLength')) {
					  entry.maxLength = entryValue.maxLength;
				  }

				  var creationDate;
				  if (entryValue._id) {
					  creationDate = new Date(parseInt(entryValue._id.substring(0, 8), 16) * 1000);
				  } else {
					  creationDate = new Date();
				  }
				  entry.valueCreatedAtTime = creationDate.getTime();
				  entry.valueCreatedAt = creationDate.toISOString();
              } else {
                  entry.value = '';
                  entry.draft = '';
                  entry.isTranslated = false;
                  entry.hasDraft = false;
                  entry.isUnTranslated = true;
				  entry.valueUpdatedAt = '';
              }
              if (!$scope.isMasterLang) {
                  if ($scope.groupLanguageEntryMap[$scope.groupId][$scope.baseLanguage._id] && $scope.getEntryValue(entry.key, $scope.baseLanguage._id)) {
                      var baseEntry = $scope.getEntryValue(entry.key, $scope.baseLanguage._id);
                      if (baseEntry.value) {
						  entry.baseValue = baseEntry.value;
					  }
                      entry.baseValueUpdatedAt = baseEntry.updatedAt;
                  } else {
					  entry.baseValue = '';
					  entry.baseValueUpdatedAt = '';
                  }
			  }

			  if ($scope.groupLanguageEntryMap[$scope.groupId][$scope.sourceLanguage._id] && $scope.getEntryValue(entry.key, $scope.sourceLanguage._id)) {
				  var sourceEntry = $scope.getEntryValue(entry.key, $scope.sourceLanguage._id);
				  if (sourceEntry.value) {
					  entry.sourceValue = sourceEntry.value;
				  }
			  } else {
				  entry.sourceValue = '';
			  }

			  // Add the times as integers that we can filter for them easier
			  if (entry.valueUpdatedAt) {
				  entry.valueUpdatedAtTime = new Date(entry.valueUpdatedAt).getTime();
			  } else {
				  entry.valueUpdatedAtTime = 0;
			  }

			  // That the filters work correctly we have to make sure that the
			  // locked value always exists
			  if (!entry.hasOwnProperty('locked')) {
				  entry.locked = false;
			  }

			  // Make sure that empty drafts & values are represented as empty
			  // strings to that filtering works correctly
			  if (!entry.draft) {
				  entry.draft = '';
			  }
			  if (!entry.value) {
				  entry.value = '';
			  }

              return entry;
          };
          $scope.updateEntryKeyMapData = function () {
						if ($scope.entryKeyMap && $scope.entryKeyMap[$scope.groupId]) {
              $scope.entryKeyMap[$scope.groupId].forEach(function (entry) {
                  var entryValue = $scope.getEntryValue(entry.key);
                  $scope.updateEntryKeyData(entry, entryValue);
							});
						}
          };
          $scope.refreshEntries = function (callback) {
			  EntryMain.refreshEntries();

              $scope.switchGroupInListView($scope.groupId, callback);
          };
          // Sets the url accordingly to how it should be displayed for the
          // given group
		  $scope.setUrlAccordingToGroup = function(groupId) {
              if (groupId === $scope.defaultGroup._id) {
                  // Is default group so change url to link without groupId set
                  $state.go('.', {
					  groupId: null
                  }, {inherit: true, notify: false});
              } else {
                  // Is the not default group so change url include groupId
				  $state.go('.', {
                      groupId: groupId
                  }, {inherit: true, notify: false});
              }
          };


          $scope.switchGroupInListView = function (groupId, callback) {
              if ($scope.groupId !== groupId) {
                  $scope.groupId = groupId;
              }

              $scope.showLoading(true);
              $scope.storeCurrentGroup($scope.groupId);
			  $scope.group = EntryMain.groups[$scope.groupId];

              //create map for group if not there
              if (!$scope.groupLanguageEntryMap[$scope.groupId]) {
                  $scope.groupLanguageEntryMap[$scope.groupId] = {};
              }


			  EntryMain.loadEntries($scope.mobileAppId, $scope.groupId, [$scope.languageId], true, function(err, result) {
				  if (err) {
					  if (callback) {
						  callback(err);
					  }
					  return;
				  }

				  $scope.groupLanguageEntryMap = EntryMain.groupLanguageEntryMap;
				  $scope.entryKeyMap = EntryMain.entryKeyMap;

				  if (!$scope.isMasterLang) {
					  $scope.refLangValues = EntryMain.groupLanguageEntryMap[$scope.groupId][$scope.baseLanguage._id];
				  }

				  $timeout(function () {
					  $scope.setUrlAccordingToGroup(groupId);
						$scope.updateEntryKeyMapData();
					  $scope.updateViewList(true);
					  $scope.showLoading(false);

					  if($stateParams.hasOwnProperty('entryId') && $stateParams.entryId) {
						  $scope.scrollToEntry($stateParams.entryId);
					  }

					  $rootScope.$broadcast('entriesChangedSuccess');

					  if (callback) {
						  callback(null, result);
					  }

				  }, 50);

				  $timeout(function(){
					$scope.initFiltersCounters();
				  }, 150);
			  });

          };

		  $scope.switchSourceLanguageInListView = function (sourceLanguage) {
			  if (sourceLanguage.name === $scope.sourceLanguage.name) {
				  return;
			  }

			  $scope.sourceLanguage = _.find($scope.languages, {name: sourceLanguage});

			  $scope.showLoading(true);
			  $state.go('.', {
				  sourceLanguage: $scope.sourceLanguage._id
			  }, {inherit: true});

			  $timeout(function() {
				  // We have to wait a little that the url updates and then
				  // we init the data again manually. It seems like $state.go
				  // does not do it by itself probably because "sourceLanguage"
				  // is just a query parameter
				  $scope.initListLanguageEntriesView();
			  });
		  };


        $scope.openDeleteSelectedModal = function (numSelected, callback) {
          var text;
          var selectedTxt = (numSelected === 1)?'selected entry': numSelected+' selected entries';
          if ($scope.mobileApp.groupsEnabled) {
            text = 'This will delete the '+selectedTxt+' and cannot be undone! Careful, this will also delete translations in other languages (it is recommended to backup the group with the Xliff export).';
          }
          else {
            text = 'This will delete the '+selectedTxt+' and cannot be undone! Careful, this will also delete translations in other languages (it is recommended to make a backup with the Xliff export).';
          }
          $timeout(function() {
				SweetAlert.swal(
				{
				  title: 'Are you sure?',
				  text: text,
				  type: 'warning',
				  showCancelButton: true,
				  confirmButtonColor: '#DD6B55',
				  confirmButtonText: 'Yes, delete!',
				  cancelButtonText: 'No, cancel!',
				  closeOnConfirm: true,
				  closeOnCancel: true
				},
				function (isConfirm) {
				  callback(isConfirm);
				}
			  );
          }, 50);
        };


          $scope.addTranslation = function (mobileAppId, languageId) {
				var groupId = $scope.getCurrentGroup() || $scope.defaultGroup._id;
						$scope.openDetailView(null, null, true);
          };

          $scope.importFromFile = function () {
			  //Making sure editing is not enabled when importing
			  $timeout(function() {
				$('.editView .buttonBar .btn[title=\'Cancel\']').click();
			  });
			  
			  var selectedEntries = $scope.getSelectedEntries();
			  var entryKeys = selectedEntries ? selectedEntries.keys : [];

			  $scope.processingImport = true;
			  var importer = new TranslationImport($scope.mobileApp, $scope.group, $scope.language, $scope.tags, $scope.tagCategories);
			  importer.selectFile(entryKeys).then(
				  function(result) {
						$scope.processingImport = false;
						$rootScope.$broadcast('entriesChanged');
				  }
			  ).catch(function (error) {
				  $scope.processingImport = false;
				  Utilities.showMessage('Error', error, 'error');
			  });
		  };



		  /**
		   * Adds translations to the translation memory
		   */
		  $scope.addToTm = function() {
			  $scope.showLoading(false);

			  var modalInstance = $modal.open({
				  templateUrl: 'modules/mobile-apps/views/add-to-tm-modal.client.view.html',
				  controller: 'AddToTmController',
				  size: 'md'
			  });

			  modalInstance.result.then(function (options) {

				  // Replace the language-option with the actual language-ids
				  if (options.languages === 'all') {
					  // Add all available languages
					  options.languages = Object.keys($scope.languages);
				  } else {
					  // Add only current language
					  options.languages = [$scope.language._id];
				  }

				  var selectedEntries = $scope.getSelectedEntries();

				  var params =
				  {
					  mobileAppId: $scope.mobileAppId,
					  teamId: $scope.mobileApp.team._id,
					  keys: selectedEntries.keys,
					  options: options
				  };

				  TranslationMemory.add(params,
					  function(response) {
						  $scope.refreshEntries();

						  var message = 'Added: ' + response.entriesAdded + '<br />Updated: ' + response.entriesUpdated;

						  if (Object.keys(response.ignoredDuplicates).length !== 0) {
							  message += '<br /><br /><strong>The following entries got skipped because they are not unique in the base language:</strong><div class="duplicate-entries"><ul>';
							  for (var translation in response.ignoredDuplicates) {
								  message += '<li><strong>' + translation + '</strong><br />' + response.ignoredDuplicates[translation].join(', ') + '</li>';
							  }
							  message += '</ul></div>';
						  } else {
							  message += '<br/>';
						  }

						  Utilities.showMessage('Success', message, 'success');
						  $scope.showLoading(false);

						  // Refresh to make sure that all languages are loaded
						  EntryMain.loadMobileApp($scope.mobileApp.team.translationMemory._id, true, function() {});
					  }, function(errResponse) {
						  // error
						  $scope.showLoading(false);
						  Utilities.showMessage('Warning', errResponse.data.message, 'warning');
					  }
				  );

			  }, function() {
				  $scope.showLoading(false);
			  });
		  };


		  /**
		   * Checks the translation memory for translations of the selected entries
		   */
		  $scope.autotranslateFromTm = function() {
			  $scope.showLoading(false);

			  var modalInstance = $modal.open({
				  templateUrl: 'modules/mobile-apps/views/autotranslate-from-tm-modal.client.view.html',
				  controller: 'AutotranslateFromTmController',
				  size: 'md'
			  });

			  modalInstance.result.then(function (options) {
				  var selectedEntries = $scope.getSelectedEntries();

				  var params =
				  {
					  mobileAppId: $scope.mobileAppId,
					  teamId: $scope.mobileApp.team._id,
					  groupId: $scope.groupId,
					  languageIds: [$scope.languageId],
					  keys: selectedEntries.keys,
					  options: options
				  };

				  TranslationMemory.autotranslate(params,
					  function(response) {
						  // success
						  $scope.showLoading(false);
						  $scope.refreshEntries();
						  Utilities.showMessage('Success', 'Translations applied: ' + response.entriesTranslationApplied, 'success');
				  }, function(errResponse) {
						  // error
						  $scope.showLoading(false);
						  Utilities.showMessage('Warning', errResponse.data.message, 'warning');
					  }
				  );

			  }, function() {
				  $scope.showLoading(false);
			  });
		  };

		  /**
		   * Opens export modal
		   */
		  $scope.exportToFile = function () {
			  var selectedEntries = $scope.getSelectedEntries();
			  var exportEntries = selectedEntries ? selectedEntries.keys : [];

			  // By default select only the currently active language
			  var selectedLanguages = [$scope.language.name];

			  var modalInstance = $modal.open({
				  templateUrl: 'modules/mobile-apps/views/export-translations-modal.client.view.html',
				  controller: 'ExportTranslationsModalController',
				  backdrop: true,
				  size: 'md',
				  resolve: {
					  ModalData: function() {
						  return {
							  mobileApp: $scope.mobileApp,
							  selectedLanguages: selectedLanguages,
							  entries: exportEntries,
							  groupId: $scope.groupId
						  };
					  }
				  }
			  }).result.catch(function(error) {
					if (!(error === 'cancel' || error === 'escape key press' || error === undefined)) {
						throw error;
					}
				});

		  };

		  $scope.stateButtonClicked = function () {
		  	  var selectedEntries = $scope.getSelectedEntries();

              if(selectedEntries.hasInOrderStatus === true) {
                  Utilities.showMessage('Translation Order Active', 'While part of a translation order, the translation status can’t be changed', 'warning');
              } else {
                  EntryStatus.openModal($scope.mobileAppId, $scope.languageId, $scope.groupId, selectedEntries.keys, $scope.viewList, $scope.tags, $scope.tagCategories);
              }

		  };

		  $scope.changeLanguage = function (languageId) {
			$scope.goToLanguageEntriesView(languageId);
		  };

		  $scope.changeTag = function (tagId) {
		  	$state.go('viewLanguage.entry.tag', {
		  		tagId: tagId
		  	}, { inherit: true });
		  };

		  $scope.tagClicked = function(){
			if($rootScope.tagFilterApplied){
				$rootScope.tagFilterApplied = false;
				$scope.changeFiltering('all');
			}
		  };

		  $scope.goToLanguageEntriesView = function(languageId){
		  	$scope.showLoading(true);
		  	$state.go('.', {
		  		languageId: languageId,
		  		deviceLanguageLong: undefined,
		  		bundleVersion: undefined,
		  		resolution: undefined,
		  		mainFilter: undefined
			  }, { inherit: true });
		  };
			

		/*********START Entry detail sidebar START*******/

				/**
				 * Returns the last part of the name of the current state
				 */
				$scope.getLastStatePart = function () {
					var stateParts = $state.current.name.split('.');
					return stateParts[stateParts.length - 1];
				};

				$scope.getCustomLastStatePart = function (name) {
					var stateParts = name.split('.');
					return stateParts[stateParts.length - 1];
				};


				/**
				 * Sets the start value data to be able to check if
				 * changes have been made
				 */
				$scope.setStartValue = function () {
					$scope.languageEntryStart = JSON.parse(JSON.stringify($scope.languageEntry));
				};


				/**
				 * Returns if there are currently any unsaved changes
				 */
				$scope.hasUnsavedChanges = function () {

					if(!$scope.languageEntryStart || !$scope.languageEntry){
						return false;
					}

					var checkProperties = [
						'key',
						'description',
						'draft',
						'value',
						'maxLength',
						'group'
					];

					var parameterName;
					for (var i = 0; i < checkProperties.length; i++) {
						parameterName = checkProperties[i];
						if ($scope.languageEntry[parameterName] !== $scope.languageEntryStart[parameterName]) {
							return true;
						}
					}

					return false;
				};


				/**
				 * Checks if there are unsaved changes and if any have been found check
				 * with user if they should be discarded
				 */
				$scope.checkUnsavedChangesProceed = function () {
					if (!$scope.hasUnsavedChanges()) {
						// No unsaved changes so go on
						return $q.when(true);
					}

					// There are unsaved changes so check with user if they
					// should be discarded
					return $q(function (resolve, reject) {
						$timeout(function () {
							SweetAlert.swal(
								{
									title: 'Unsaved changes',
									text: 'There are unsaved changes. Do you want to discard the changes and proceed?',
									type: 'warning',
									showCancelButton: true,
									confirmButtonColor: '#DD6B55',
									confirmButtonText: 'Yes, discard changes!',
									cancelButtonText: 'No, cancel!',
									closeOnConfirm: true,
									closeOnCancel: true
								},
								function (isConfirm) {
									return resolve(isConfirm);
								}
							);
						}, 50);
					});
				};


				/**
				 * Returns the role of the currently logged in user in
				 * the app
				 */
				$scope.getCurrentRoleInApp = function () {
					var team = $scope.mobileApp.team;
					var userId = $scope.authentication.user._id;
					for (var i = 0; i < team.members.length; i++) {
						if (userId === team.members[i].user) {
							$scope.roleInApp = team.members[i].role;
						}
					}
				};


				/**
				 * Displays the loading screen
				 */
				$scope.showLoadingDetailView = function (loading) {
					$timeout(function () {
						$scope.loadingDetailView = loading;
					});
				};


				/**
				 * Closes modal and returns the given data.
				 * If there are unsaved changes it checks first
				 * with the user if he really wants to lose the changes.
				 */
				$scope.closeWithUnsavedCheck = function (data) {
					$scope.checkUnsavedChangesProceed()
						.then(
							function (proceed) {
								if (proceed) {
									$scope.close(data);
								}
							}
						);
				};


				/**
				 * Closes modal and returns the given data
				 */
				$scope.close = function (data) {
					var lastStatePart = $scope.getLastStatePart();

					// Set the state it it is not set already
					if (['edit', 'new'].indexOf(lastStatePart) !== -1) {
						$state.go('^', {
							entryId: ''
						}, {inherit: true, notify: false});
					} else if(lastStatePart === 'state') {
						switch ($state.current.name) {
							case 'viewLanguage.entry.edit.state':
							case 'viewLanguage.entry.new.state':
								$state.go('viewLanguage.entry.state', {
									stateName: $state.params.stateName,
									entryId: ''
								}, {inherit: true, notify: false});
								break;
							case 'viewLanguage.entry.tags.edit.state':
								$state.go('viewLanguage.entry.tags.state', {
									stateName: $state.params.stateName,
									entryId: ''
								}, {inherit: true, notify: false});
								break;
							case 'viewLanguage.entry.tag.edit.state':
								$state.go('viewLanguage.entry.tag.state', {
									tag: $state.params.tag,
									stateName: $state.params.stateName,
									entryId: ''
								}, {inherit: true, notify: false});
								break;
							case 'viewLanguage.entry.files.edit.state':
								$state.go('viewLanguage.entry.files.state', {
									entryId: '',
									stateName: $state.params.stateName
								}, {inherit: true, notify: false});
								break;
							case 'viewLanguage.entry.file.edit.state':
									$state.go('viewLanguage.entry.file.state', {
										entryId: '',
										fileName: $state.params.fileName,
										stateName: $state.params.stateName
									}, {inherit: true, notify: false});
									break;
							default:
								break;
						}
					}

					$rootScope.$broadcast('EntryDetailClosed', null);
					$('.entry-detail-content').css({'width': ''});
					$('.detail-view-active').removeClass('detail-view-active');
					if(!$scope.isSideBarMinimized){
						TagMain.adjustSidebarWidth();
					}
					
					$scope.showDetailView = false;
					$rootScope.isDetailViewOpened = false;
					$scope.bothSidesOpened = false;

					if($rootScope.isLeftSideOpened){
						$scope.setLeftSideResizing();
					}
				};

				/**
				 * Sets the current draft as new value
				 */
				$scope.approveDraft = function (langEntry, event) {
					event.preventDefault();
					var draft = langEntry.draft;
					$scope.languageEntry.draft = '';
					$scope.languageEntry.value = draft;
				};


				/**
				 * Show history of entry
				 */
				$scope.toggleHistory = function () {
					var changeLog = {};
					changeLog.headline = 'for ID: ' + $scope.languageEntry.key;
					changeLog.query = {
						key: $scope.languageEntry.key
					};

					var asideInstance = $aside.open({
						templateUrl: 'modules/mobile-apps/views/changelog.client.view.html',
						controller: 'ChangelogController',
						placement: 'left',
						size: 'lg',
						resolve: {
							loadData: changeLog
						}
					});
				};


				/**
				 * Show history of entry by language
				 */
				$scope.toggleLangKeyHistory = function(){

					var changeLog = {};
					changeLog.query = {};

					if($scope.isMasterLang){
						changeLog.query = { key: $scope.languageEntry.key, languageId: $scope.language._id };
					} else {
						changeLog.query = { key: $scope.languageEntry.key, languageId: { $in: [$scope.language._id, $scope.mobileApp._baseLanguage._id] } };
					}

					if(EntryMain.languages.hasOwnProperty($stateParams.languageId)) {
						changeLog.headline = 'for Language: ' + $scope.availableLanguages[$scope.language.name];
					}

					var asideInstance = $aside.open({
						templateUrl: 'modules/mobile-apps/views/changelog.client.view.html',
						controller: 'ChangelogController',
						placement: 'left',
						size: 'lg',
						resolve: {
							loadData: changeLog
						}
					});
				};


				$scope.switchSourceLanguageInEditView = function (sourceLanguage) {
					$scope.sourceLanguage = _.find($scope.languages, { name: sourceLanguage });
					if (!$scope.languageEntryMap[sourceLanguage]) {
						var params = {
							mobileAppId: $scope.mobileAppId,
							languageId: $scope.sourceLanguage._id,
							entryId: $scope.entryId
						};
						$scope.languageEntryMap[$scope.sourceLanguage.name] = LanguageEntries.get(params);
					}
				};


				/**
				 * Create new entry
				 */
				$scope._create = function (cb) {

					var languageEntryData = {
						key: $scope.languageEntry.key,
						value: $scope.languageEntry.value,
						description: $scope.languageEntry.description,
						draft: $scope.languageEntry.draft,
						group: $scope.languageEntry.groups,
						metadata: $scope.languageEntry.metadata
					};

					if ($scope.languageEntry.maxLength !== '') {
						languageEntryData.maxLength = parseInt($scope.languageEntry.maxLength);
					}

					var languageEntry = new LanguageEntries(languageEntryData);

					// Create entry
					languageEntry.$save({
						mobileAppId: $scope.mobileAppId,
						languageId: $scope.languageId,
						groupId: $scope.groupId
					}, function (response) {
						// Track the Entry Create, for the values value, draft and
						// save only if they got set or not
						var eventData = {
							key: $scope.languageEntry.key,
							value: !!$scope.languageEntry.value,
							draft: !!$scope.languageEntry.draft,
							description: !!$scope.languageEntry.description
						};
						EventTracker.track('Entry Create Success', 'Entry Create', eventData);

						// Makes sure that the entry list gets reloaded
						// so that the new entry does get displayed
						$rootScope.$broadcast('entriesChanged');
						// $rootScope.$broadcast('entryChanged', {entry: response});

						return cb(null, response);
					}, function (errorResponse) {
						return cb(errorResponse);
					});
				};


				/**
				 * Update existing Language entry
				 */
				$scope._update = function (callback) {

					var languageEntry = $scope.languageEntry;

					languageEntry.$update({
						mobileAppId: $scope.mobileAppId,
						languageId: $scope.languageId,
						entryId: $scope.entryId
					}, function (response) {

						if ($scope.languageEntry.group !== $scope.languageEntryStart.group) {
							// Makes sure that the entry list gets reloaded
							// so that the entry does not get displayed under
							// the current group anymore.
							$rootScope.$broadcast('entriesChanged');
						}

                        $rootScope.$broadcast('entryChanged', { entry: response });

						if (angular.isFunction(callback)) {
							callback(null, response);
						}
					}, function (errorResponse) {
						if (angular.isFunction(callback)) {
							callback(errorResponse);
						}
					});
				};


				/**
				 * Removes the entry
				 */
				$scope.remove = function (cb) {
					// Track the Entry Delete, for the values value and draft
					// save only if they were set or not
					var eventData = {
						key: $scope.languageEntry.key,
						value: !!$scope.languageEntry.value,
						draft: !!$scope.languageEntry.draft,
						description: !!$scope.languageEntry.description
					};

					$scope.languageEntry.$remove({
						mobileAppId: $scope.mobileAppId,
						languageId: $scope.languageId
					}, function () {
						// Makes sure that the entry list gets reloaded
						// so that the deleted entry does not get displayed
						// anymore
						$rootScope.$broadcast('entriesChanged');

						// Reload the tags that not deleted entries
						// do not get displayed as part of a tag
						$rootScope.$broadcast('tagsChanged');

						EventTracker.track('Entry Delete Success', 'Entry Delete', eventData);

						if (angular.isFunction(cb)) {
							cb();
						}
					}, function (errorResponse) {
						return cb(errorResponse);
					});
				};

				/**
				 * Opens modal for locking segment
				 */
				$scope.showLockToggleModal = function() {
					var lock = true;
					if ($scope.languageEntry.locked) {
						lock = false;
					} 
					var errorCallback = function (errorResponse) {
						$scope.error = errorResponse.data.message;
						$scope.languageEntry.locked = !lock;
					};
					var successCallback = function (data) {
						$scope.languageEntry.valueUpdatedAt = new Date();
						$rootScope.$broadcast('entryChanged', { entry: $scope.languageEntry });
					};

					var modalInstance = $modal.open({
						templateUrl: 'modules/mobile-apps/views/lock-segments-modal.client.view.html',
						controller: 'LockSegmentController',
						backdrop: true,
						size: 'sm',
						resolve: {
							ModalData: function() {
								return {
									language: $scope.availableLanguages[$scope.language.name],
									locked: $scope.languageEntry.locked
								};
							}
						}
					});
					modalInstance.result.then(function (options) {
						$scope.languageEntry.locked = lock;
						if (options.changeMany) {
							if (lock) {
								LockEntry.lockAll({
									mobileAppId: $scope.mobileAppId,
									entryId: $scope.entryId
								}, null, successCallback, errorCallback);
							} else {
								LockEntry.unlockAll({
									mobileAppId: $scope.mobileAppId,
									entryId: $scope.entryId
								}, null, successCallback, errorCallback);
							}
						} else {
							if (lock) {
								LockEntry.lock({
									mobileAppId: $scope.mobileAppId,
									languageId: $scope.languageId,
									entryId: $scope.entryId
								}, null, successCallback, errorCallback);
							} else {
								LockEntry.unlock({
									mobileAppId: $scope.mobileAppId,
									languageId: $scope.languageId,
									entryId: $scope.entryId
								}, null, successCallback, errorCallback);
							}
						}
					});
				};
				
				$scope.openDeleteLanguageEntryModal = function () {
					$timeout(function () {
						SweetAlert.swal(
							{
								title: 'Are you sure?',
								text: 'This will delete the Translation ID "' + $scope.languageEntry.key + '" in all languages. This can not be recovered!',
								type: 'warning',
								showCancelButton: true,
								confirmButtonColor: '#DD6B55',
								confirmButtonText: 'Yes, delete it!',
								cancelButtonText: 'No, cancel!',
								closeOnConfirm: true,
								closeOnCancel: true
							},
							function (isConfirm) {
								if (isConfirm) {
									$scope.remove(function (err) {
										if (err) {
											Utilities.showMessageErrorResponse(err);
											return;
										}
										return $scope.close();
									});
								}
							}
						);
					}, 50);
				};


				$scope.save = function () {

					if ($scope.entryId) {
						// Edit existing translation
						$scope._update(function (err, response) {
							if (err) {
								Utilities.showMessageErrorResponse(err);
								return;
							} else {
								$scope.setStartValue();
							}

							return;
						});
					} else {
						// Create new translation
						$scope._create(function (err, response) {
							if (err) {
								Utilities.showMessageErrorResponse(err);
								return;
							}

							return $scope.close();
						});
					}

				};


				/**
				 * Goes to the previous entry
				 */
				$scope.goToPrevious = function () {
					$scope.checkUnsavedChangesProceed()
						.then(
							function (proceed) {
								if (proceed) {
									$rootScope.$broadcast('liveEditEntrySelectIndex', { index: --$scope.entryIndex, direction: 'negative', openEditModal: true });
								}
							}
						);
				};


				/**
				 * Goes to the next entry
				 */
				$scope.goToNext = function () {
					$scope.checkUnsavedChangesProceed()
						.then(
							function (proceed) {
								if (proceed) {
									$rootScope.$broadcast('liveEditEntrySelectIndex', { index: ++$scope.entryIndex, direction: 'positive', openEditModal: true });
								}
							}
						);
				};


				$scope.initEditTranslation = function () {
					$scope.sideBarModeName = 'Update Translation';
					var lastStatePart = $scope.getLastStatePart();

					// Set the state if it's not set already
					switch (lastStatePart) {
						case 'edit':
							$state.go('.', { entryId: $scope.entryId }, { inherit: true, notify: false });
							break;
						case 'new':
							$state.go($state.current.name.replace('.new', '.edit'), {entryId: $scope.entryId}, { inherit: true, notify: false });
							break;
						case 'file':
						case 'files':
							$scope.bothSidesOpened = true;
							$state.go('.edit', { entryId: $scope.entryId }, { inherit: true, notify: false });
							break;
						case 'tag':
						case 'tags':
							if ($scope.breadcrumbs.displayTags && !$scope.isSideBarMinimized) {
								$scope.bothSidesOpened = true;
							} else {
								$scope.bothSidesOpened = false;
							}
							$state.go('.edit', { entryId: $scope.entryId }, { inherit: true, notify: false });
							break;
						case 'state':
							if ($state.current.name.indexOf('tag') !== -1) {
								if ($scope.breadcrumbs.displayTags && !$scope.isSideBarMinimized) {
									$scope.bothSidesOpened = true;
								} else {
									$scope.bothSidesOpened = false;
								}
							} else if ($state.current.name.indexOf('file') !== -1) {
								$scope.bothSidesOpened = true;
							}
							if($state.current.name.indexOf('edit') !== -1){
								$state.go('.', { entryId: $scope.entryId }, { inherit: true, notify: false });
							} else{
								$state.go('.edit', { entryId: $scope.entryId }, { inherit: true, notify: false });
							}
							break;
						default:
							$state.go('.edit', { entryId: $scope.entryId }, { inherit: true, notify: false });
							break;
					}

					//Removing any hover that could be active
					$('.detail-view-active').removeClass('detail-view-active');
					//Adding hover class to entry element
					$('display-tags[entry-id=\'' + $scope.entryId + '\']').parents('.list-group-item').addClass('detail-view-active');

					var numEntries = 0;
					if ($scope.entryKeyMap.hasOwnProperty($scope.groupId)) {
						numEntries = $scope.entryKeyMap[$scope.groupId].length;
					}

					$scope.setPrevNextButtons();

					EntryMain.loadEntry($scope.mobileAppId, $scope.languageId, $scope.entryId)
								.then(
									function(data) {
										$scope.showLoadingDetailView(false);

										$scope.languageEntryMap = EntryMain.languageEntryMap;
										$scope.languageEntry = $scope.languageEntryMap[$scope.language.name];
										$scope.languageEntry.baseValue = $scope.languageEntryMap[$scope.mobileApp.baseLanguage].value;

										$scope.baseLanguage = _.find($scope.languages, {name: $scope.mobileApp.baseLanguage});
										$scope.sourceLanguage = _.find($scope.languages, {name: $scope.mobileApp.baseLanguage});
										$scope.isMasterLang = $scope.language.name === $scope.mobileApp.baseLanguage;

										$scope.sourceLanguageToShow = $scope.sourceLanguage.name;
										$scope.languageToShowEditMode = $scope.mobileApp.baseLanguage;
										
										// Add the language ids for the entry-warnings directive
										$scope.languagesWarning = {
											base: $scope.mobileApp.baseLanguage,
											entry: $scope.language.name
										};

										$scope.addMetadata();
										$scope.setStartValue();
										$scope.getCurrentRoleInApp();
									}
								)
								.catch(
									function(err) {
										Utilities.showMessageErrorResponse(err);
										$scope.showLoadingDetailView(false);
									}
								);
						

					$scope.addMetadata();
					$scope.setStartValue();
					$scope.getCurrentRoleInApp();
					$timeout(function () {
						$scope.scrollToEntry($scope.entryId, 20, false);
					}, 200);
				};


				$scope.initNewTranslation = function () {
					var lastStatePart = $scope.getLastStatePart();

					// Set the state it it is not set already
					switch (lastStatePart) {
						case 'edit':
							$state.go($state.current.name.replace('.edit', '.new'), { entryId: null }, { inherit: true, notify: false });
							break;
						case 'new':
							$state.go('.', { entryId: null }, { inherit: true, notify: false });
							break;
						case 'file':
						case 'files':
							$scope.bothSidesOpened = true;
							$state.go('.new', { entryId: null }, { inherit: true, notify: false });
							break;
						case 'tag':
						case 'tags':
							if ($scope.breadcrumbs.displayTags && !$scope.isSideBarMinimized) {
								$scope.bothSidesOpened = true;
							} else {
								$scope.bothSidesOpened = false;
							}
							$state.go('.new', { entryId: null }, { inherit: true, notify: false });
							break;
						case 'state':
							if ($state.current.name.indexOf('tag') !== -1) {
								if ($scope.breadcrumbs.displayTags && !$scope.isSideBarMinimized) {
									$scope.bothSidesOpened = true;
								} else {
									$scope.bothSidesOpened = false;
								}
							} else if ($state.current.name.indexOf('file') !== -1) {
								$scope.bothSidesOpened = true;
							}
							if ($state.current.name.indexOf('new') !== -1) {
								$state.go('.', { entryId: $scope.entryId }, { inherit: true, notify: false });
							} else {
								$state.go('.new', { entryId: $scope.entryId }, { inherit: true, notify: false });
							}
							break;
						default:
							$state.go('.new', { entryId: null }, { inherit: true, notify: false });
							break;
					}

					$scope.sideBarModeName = 'Add Translation';
					$('.detail-view-active').removeClass('detail-view-active');

					$scope.showLoadingDetailView(false);

					$scope.setStartValue();
					$scope.addMetadata();
					$scope.getCurrentRoleInApp();
				};

				$scope.addMetadata = function () {
					//Add metadata
					var currentMetadata = $scope.languageEntry ? _.clone($scope.languageEntry.metadata) : null;
					var metadataBones = $scope.mobileApp.metadata ? _.clone($scope.mobileApp.metadata) : null;
					if (!currentMetadata && metadataBones && metadataBones.length) {
						$scope.languageEntry.metadata = [];
						metadataBones.forEach(function (item) {
							$scope.languageEntry.metadata.push({
								id: item.id,
								key: item.fieldName,
								value: null,
								description: item.description,
								order: item.order
							});
						});
					} else if (currentMetadata && metadataBones && currentMetadata.length !== metadataBones.length) {
						$scope.languageEntry.metadata = [];
						metadataBones.forEach(function (item) {
							var currentMetadataItem, currentMetadataItemValue;
							if (currentMetadata && currentMetadata.length) {
								currentMetadataItem = currentMetadata.find(function (m) { return m.key === item.fieldName; });
							} else {
								currentMetadataItem = null;
							}
							if (currentMetadataItem) {
								currentMetadataItemValue = currentMetadataItem.value;
							} else {
								currentMetadataItemValue = null;
							}
							$scope.languageEntry.metadata.push({
								id: item.id,
								key: item.fieldName,
								value: currentMetadataItemValue,
								description: item.description,
								order: item.order
							});
						});
					} else if (currentMetadata && metadataBones && currentMetadata.length === metadataBones.length) {
						metadataBones.forEach(function (item, index) {
							var currentMetadataItem, currentMetadataItemValue;
							if (currentMetadata && currentMetadata.length) {
								currentMetadataItem = currentMetadata.find(function (m) { return m.key === item.fieldName; });
							} else {
								currentMetadataItem = null;
							}
							if (currentMetadataItem) {
								currentMetadataItemValue = currentMetadataItem.value;
							} else {
								currentMetadataItemValue = null;
							}
							$scope.languageEntry.metadata[index] = {
								id: item.id,
								key: item.fieldName,
								value: currentMetadataItemValue,
								description: item.description,
								order: item.order
							};
						});
					}
				};

				/**
				 * Initializes the view
				 */
				$scope.initDetailView = function () {
					$scope.showLoadingDetailView(true);

					// Load the glossary data
					GlossaryMain.loadGlossary($scope.mobileAppId, true, function (err, entries) { });

					if ($scope.entryId) {
						// Edit existing translation
						$scope.initEditTranslation();
					} else {
						// Create new translation
						$scope.initNewTranslation();
					}

					if(!$scope.isSideBarMinimized){
						TagMain.adjustSidebarWidth();
					}
				};

				$scope.openDetailView = function(entryIndex, entryId, openDirectly) {
					$scope.showPreviousButton = false;
					$scope.showNextButton = false;

					if(entryId){
						$scope.entryId = entryId;
					} else if(entryIndex !== undefined && entryIndex !== null && $scope.viewList && $scope.viewList[entryIndex]){
						$scope.entryId = $scope.viewList[entryIndex]._id;
					} else if($scope.entryKeyMap[$scope.groupId] && $scope.entryKeyMap[$scope.groupId][entryIndex]){
						$scope.entryId = $scope.entryKeyMap[$scope.groupId][entryIndex]._id;
					} else {
						$scope.entryId = undefined;
					}
					
					if(!$rootScope.isLiveEditActive && (!$rootScope.isDetailViewOpened || openDirectly && $scope.lastEntryId !== $scope.entryId)){
						$scope.showLoadingDetailView(true);
					
						$scope.showDetailView = true;
						$rootScope.isDetailViewOpened = true;
						
						$scope.entryIndex = entryIndex;
						$scope.lastEntryId = $scope.entryId;
						$scope.languageEntry = {
							key: '',
							value: '',
							description: '',
							group: $scope.groupId,
							metadata: []
						};
						$scope.languageEntryStart = {};
						$scope.sourceLanguageToShow = 'en'; // Set reasonable default till actualy value set
						$scope.availableLanguages = AvailableLanguages.get();

						if($rootScope.isLeftSideOpened){
							$scope.setLeftSideResizing();
						}

						$(document).on('mouseover', '.detailViewSpacing', function(el){
							if($rootScope.isDetailViewOpened === true){
								$(this).find('.editableEntry').addClass('notEditableEntry');
							} else {
								$(this).find('.editableEntry').removeClass('notEditableEntry');
							}
						});

						$scope.initDetailView();
					} else {
						$scope.setPrevNextButtons();
					}
				};

				$scope.$on('openDetailView', function (event, mobileAppId, languageId, groupId, entryId, entryIndex, openDirectly) {
					$scope.openDetailView(entryIndex, entryId, openDirectly);
				});

				$(document).on('mouseover', '.list-group-item', function(el){
					if($rootScope.isLiveEditActive === true){
						$(this).addClass('not-clickable');
					} else {
						$(this).removeClass('not-clickable');
					}
				});

				$scope.setPrevNextButtons = function(){
					if($scope.viewList){
						if($scope.entryIndex !== undefined && $scope.viewList[$scope.entryIndex] && $scope.viewList[$scope.entryIndex]._id !== $scope.entryId){
							Object.keys($scope.viewList).forEach(function(item, index){
								if($scope.viewList[item]._id === $scope.entryId){
									$scope.entryIndex = index;
								}	
							});
						}
						if ($scope.viewList[$scope.entryIndex] && $scope.entryIndex > 0) {
							$scope.showPreviousButton = true;
						} else {
							$scope.showPreviousButton = false;
						}
						if ($scope.entryIndex < $scope.viewList.length - 1) {
							$scope.showNextButton = true;
						} else {
							$scope.showNextButton = false;
						}
					} else {
						$scope.showPreviousButton = false;
						$scope.showNextButton = false;
					}
				};
		
		/*********END Entry detail sidebar END*******/

		/* Left Side Rezising */
		$scope.resizePanels = function (ui, xAdjust) {
			var leftWidth = ui.size.width + xAdjust;
			var mainRightWidth = document.body.clientWidth - leftWidth;
			var mainWidth = mainRightWidth * 0.55;
			var rightWidth = mainRightWidth * 0.45;
			leftWidth += 'px';
			mainWidth += 'px';
			rightWidth += 'px';

			if($rootScope.isDetailViewOpened){
				$('.main-content').css({ 'width': mainWidth, 'margin-left': leftWidth });
				$('.entry-detail-content').css({ 'width': rightWidth });
			} else {
				$('.main-content').css({ 'width': mainRightWidth, 'margin-left': leftWidth });
			}
			$('.side-content').css({ 'width': leftWidth });
		};

		$scope.setLeftSideResizing = function () {
			if ($rootScope.isLeftSideOpened && !$rootScope.isLeftSideResizible) {
				var maxWidth, minWidth;
				minWidth = 175;
				if (document.body.clientWidth > 1650) {
					maxWidth = 600;
				} else {
					maxWidth = 450;
				}

				$timeout(function () {
					$rootScope.isLeftSideResizible = true;
					var xAdjust = 60;
					$('.side-content').resizable({
						handles: 'e',
						maxWidth: maxWidth,
						start: function (e, ui) {
							$rootScope.isLeftSideResizing = true;
						},
						resize: function (e, ui) {
							$scope.resizePanels(ui, xAdjust);
						},
						stop: function (e, ui) {
							$scope.resizePanels(ui, xAdjust);
							if (ui.size.width + xAdjust <= minWidth) {
								$scope.toggleSideBar();
							}
							$timeout(function(){
								$rootScope.isLeftSideResizing = false;
							}, 175);
						}
					});
				}, 1000);
			} else if(!$rootScope.isLeftSideOpened && !$scope.isLeftSideStillOpened && $rootScope.isLeftSideResizible) {
				$('.side-content, .entry-detail-content').css({ 'width': '' });
				$('.main-content').css({ 'width': '', 'margin-left': '' });
				$rootScope.isLeftSideResizing = false;
				$rootScope.isLeftSideResizible = false;
			}
		};

		/*Side bar toggling*/
		$scope.toggleSideBar = function(){
			if($scope.isSideBarMinimized){
				$('.side-content').removeClass('collapsed');
				$('.main-content').removeClass('extended');
				
				if($rootScope.isDetailViewOpened){
					$scope.bothSidesOpened = true;
				}
				$rootScope.isLeftSideOpened = true;
				TagMain.adjustSidebarWidth();
			} else {
				$('.side-content, .entry-detail-content').css({ 'width': '' });
				$('.main-content').css({ 'width': '', 'margin-left': '' });
				$('.side-content').addClass( 'collapsed' );
				$('.main-content').addClass( 'extended' );

				$scope.bothSidesOpened = false;
				$rootScope.isLeftSideOpened = false;
			}
			$scope.isSideBarMinimized = !$scope.isSideBarMinimized;
			$scope.setLeftSideResizing();
		};

		$rootScope.$on('minimizeTagsBar',
			function (event, toState, toParams, fromState, fromParams) {
				$scope.toggleSideBar();
			}
		);

		$scope.closeSideBar = function(){
			$rootScope.isLeftSideOpened = false;
			$scope.bothSidesOpened = false;
			$scope.isSideBarMinimized = false;
			setTimeout(function(){
				$scope.setPrevNextButtons();				
			}, 250);
		};

		/**
		 * Create a jira ticket
		 */

		$scope.createJiraIssue = function() {
			JiraApi.getConfiguration({ mobileAppId: $scope.mobileApp._id }).$promise
				.then(
					function (jiraConfig) {
					    if(jiraConfig.missingJiraConfig === true) {
					        return Utilities.showMessage('Error!', 'missing Jira configuration', 'error');
                        }
						var loadData = {
							mobileApp: $scope.mobileApp,
							selectedEntryKeys: $scope.getSelectedEntries().keys,
							selectedEntryDescIds: $scope.getSelectedEntries().descIds,
							jiraConfig: jiraConfig
						};
						
						var modalInstance = $modal.open({
							templateUrl: 'modules/mobile-apps/views/add-jira-issue-modal.client.view.html',
							controller: 'AddJiraIssueModalController',
							backdrop: true,
							size: 'md',
							resolve: {
								ModalData: function() {
									return loadData;
								}
							}
						}).result.catch(function(error) {
							if (!(error === 'cancel' || error === 'escape key press' || error === undefined)) {
								throw error;
							}
						});
					}
				).
			catch(
				function (error) {
					Utilities.showMessageErrorResponse(error);
				}
			);
		};
	}
]
);
